"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeSortEnum = exports.PrivateStatusEnum = exports.PriceTypeSortEnum = exports.PriceKind = exports.ParsedSaleTypeSortEnum = exports.ParsedLotTypeSortEnum = exports.OrderTypeSortEnum = exports.NotificationHistoryTypeSortEnum = exports.NftSaleTypeSortEnum = exports.NftPartnerTypeSortEnum = exports.NftNetworkTypeSortEnum = exports.NftCurrency = exports.MarketProductTypeSortEnum = exports.MarketCollectionTypeSortEnum = exports.LotTypeSortEnum = exports.InstagramAccountTypeSortEnum = exports.ImageTypeSortEnum = exports.EventTypeSortEnum = exports.DescriptionTypeSortEnum = exports.DealRoomTypeSortEnum = exports.DealRoomStatus = exports.DealRoomMessageTypeSortEnum = exports.DealRoomMessageName = exports.DealRoomFilterStatus = exports.CurrencyTypeSortEnum = exports.Currency = exports.CuratedDropTypeSortEnum = exports.ContractTypeSortEnum = exports.ConditionEnum = exports.CollectionTypeSortEnum = exports.CollectableTypeSortEnum = exports.CategoryTypeSortEnum = exports.BuyersPremiumRateTypeSortEnum = exports.BitpayInvoiceTypeSortEnum = exports.AuctionHouseTypeSortEnum = exports.AttachmentTypeSortEnum = exports.ArtworkTypeSortEnum = exports.ArtworkTagTypeSortEnum = exports.ArtistTypeSortEnum = exports.ArticleTypeSortEnum = exports.ApproximateEditionSizeEnum = exports.AllowlistUsersTypeSortEnum = exports.AllowlistTypeSortEnum = exports.ActionTypeEnum = exports.AddContactPhoneVerify = exports.AddContactPhoneResendCode = exports.AddContactPhoneSendCode = exports.AddContactEmailVerify = exports.AddContactEmailResendCode = exports.AddContactEmailSendCode = void 0;
exports.WishlistTypeSortEnum = exports.WishlistStatus = exports.WishlistSize = exports.WishlistPurchaseTimeline = exports.WhitelistWalletTypeSortEnum = exports.WhitelistTypeSortEnum = exports.UserWalletTypeSortEnum = exports.UserTypeSortEnum = exports.UserStatus = exports.UserSocialLinkTypeSortEnum = exports.UserRole = exports.UserProfileTypeSortEnum = exports.UserAuthWalletTypeSortEnum = exports.Unit = exports.TokenTypeSortEnum = exports.TokenTransferTypeSortEnum = exports.StripeInvoiceTypeSortEnum = exports.StatusEnum = exports.SortByTotalSales = exports.SizeFilterValue = exports.SizeFilter = exports.SaleTypeSortEnum = exports.SaleTransactionTypeSortEnum = exports.RelatedArtistTypeSortEnum = exports.ProductWishlistUnionSortArgument = exports.ProductUnits = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AddContactEmailSendCode = (0, graphql_tag_1.default) `
    mutation addContactEmailSendCode($email: String!, $redirect: String) {
  attachEmailSendMagicLink(email: $email, redirect: $redirect) {
    isSuccess
  }
}
    `;
exports.AddContactEmailResendCode = (0, graphql_tag_1.default) `
    mutation addContactEmailResendCode {
  attachEmailResendMagicLink {
    isSuccess
  }
}
    `;
exports.AddContactEmailVerify = (0, graphql_tag_1.default) `
    mutation addContactEmailVerify($token: String!) {
  attachEmailVerify(token: $token) {
    isSuccess
  }
}
    `;
exports.AddContactPhoneSendCode = (0, graphql_tag_1.default) `
    mutation addContactPhoneSendCode($phoneNumber: String!) {
  attachPhoneNumberSendCode(phoneNumber: $phoneNumber) {
    isSuccess
  }
}
    `;
exports.AddContactPhoneResendCode = (0, graphql_tag_1.default) `
    mutation addContactPhoneResendCode {
  attachPhoneNumberResendCode {
    isSuccess
  }
}
    `;
exports.AddContactPhoneVerify = (0, graphql_tag_1.default) `
    mutation addContactPhoneVerify($code: String!) {
  attachPhoneNumberVerify(code: $code) {
    isSuccess
  }
}
    `;
var ActionTypeEnum;
(function (ActionTypeEnum) {
    ActionTypeEnum["AcceptAnOffer"] = "ACCEPT_AN_OFFER";
    ActionTypeEnum["DeclineAnOffer"] = "DECLINE_AN_OFFER";
    ActionTypeEnum["MakeAnOffer"] = "MAKE_AN_OFFER";
})(ActionTypeEnum = exports.ActionTypeEnum || (exports.ActionTypeEnum = {}));
var AllowlistTypeSortEnum;
(function (AllowlistTypeSortEnum) {
    AllowlistTypeSortEnum["AnnouncementDateAsc"] = "ANNOUNCEMENT_DATE_ASC";
    AllowlistTypeSortEnum["AnnouncementDateDesc"] = "ANNOUNCEMENT_DATE_DESC";
    AllowlistTypeSortEnum["DefaultValueAsc"] = "DEFAULT_VALUE_ASC";
    AllowlistTypeSortEnum["DefaultValueDesc"] = "DEFAULT_VALUE_DESC";
    AllowlistTypeSortEnum["EndDateAsc"] = "END_DATE_ASC";
    AllowlistTypeSortEnum["EndDateDesc"] = "END_DATE_DESC";
    AllowlistTypeSortEnum["IdAsc"] = "ID_ASC";
    AllowlistTypeSortEnum["IdDesc"] = "ID_DESC";
    AllowlistTypeSortEnum["NameAsc"] = "NAME_ASC";
    AllowlistTypeSortEnum["NameDesc"] = "NAME_DESC";
    AllowlistTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    AllowlistTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    AllowlistTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    AllowlistTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    AllowlistTypeSortEnum["StartDateAsc"] = "START_DATE_ASC";
    AllowlistTypeSortEnum["StartDateDesc"] = "START_DATE_DESC";
})(AllowlistTypeSortEnum = exports.AllowlistTypeSortEnum || (exports.AllowlistTypeSortEnum = {}));
var AllowlistUsersTypeSortEnum;
(function (AllowlistUsersTypeSortEnum) {
    AllowlistUsersTypeSortEnum["AllowlistIdAsc"] = "ALLOWLIST_ID_ASC";
    AllowlistUsersTypeSortEnum["AllowlistIdDesc"] = "ALLOWLIST_ID_DESC";
    AllowlistUsersTypeSortEnum["AllowAsc"] = "ALLOW_ASC";
    AllowlistUsersTypeSortEnum["AllowDesc"] = "ALLOW_DESC";
    AllowlistUsersTypeSortEnum["IdAsc"] = "ID_ASC";
    AllowlistUsersTypeSortEnum["IdDesc"] = "ID_DESC";
    AllowlistUsersTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    AllowlistUsersTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    AllowlistUsersTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    AllowlistUsersTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    AllowlistUsersTypeSortEnum["UserAsc"] = "USER_ASC";
    AllowlistUsersTypeSortEnum["UserDesc"] = "USER_DESC";
    AllowlistUsersTypeSortEnum["UserIdAsc"] = "USER_ID_ASC";
    AllowlistUsersTypeSortEnum["UserIdDesc"] = "USER_ID_DESC";
})(AllowlistUsersTypeSortEnum = exports.AllowlistUsersTypeSortEnum || (exports.AllowlistUsersTypeSortEnum = {}));
var ApproximateEditionSizeEnum;
(function (ApproximateEditionSizeEnum) {
    ApproximateEditionSizeEnum["LimitedEdition"] = "LIMITED_EDITION";
    ApproximateEditionSizeEnum["OpenEdition"] = "OPEN_EDITION";
    ApproximateEditionSizeEnum["Unique"] = "UNIQUE";
    ApproximateEditionSizeEnum["Unknown"] = "UNKNOWN";
})(ApproximateEditionSizeEnum = exports.ApproximateEditionSizeEnum || (exports.ApproximateEditionSizeEnum = {}));
var ArticleTypeSortEnum;
(function (ArticleTypeSortEnum) {
    ArticleTypeSortEnum["AuthorAsc"] = "AUTHOR_ASC";
    ArticleTypeSortEnum["AuthorDesc"] = "AUTHOR_DESC";
    ArticleTypeSortEnum["BlogHandleAsc"] = "BLOG_HANDLE_ASC";
    ArticleTypeSortEnum["BlogHandleDesc"] = "BLOG_HANDLE_DESC";
    ArticleTypeSortEnum["BlogIdAsc"] = "BLOG_ID_ASC";
    ArticleTypeSortEnum["BlogIdDesc"] = "BLOG_ID_DESC";
    ArticleTypeSortEnum["BodyHtmlAsc"] = "BODY_HTML_ASC";
    ArticleTypeSortEnum["BodyHtmlDesc"] = "BODY_HTML_DESC";
    ArticleTypeSortEnum["CreatedAtAsc"] = "CREATED_AT_ASC";
    ArticleTypeSortEnum["CreatedAtDesc"] = "CREATED_AT_DESC";
    ArticleTypeSortEnum["HandleAsc"] = "HANDLE_ASC";
    ArticleTypeSortEnum["HandleDesc"] = "HANDLE_DESC";
    ArticleTypeSortEnum["IdAsc"] = "ID_ASC";
    ArticleTypeSortEnum["IdDesc"] = "ID_DESC";
    ArticleTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    ArticleTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    ArticleTypeSortEnum["PublishedAtAsc"] = "PUBLISHED_AT_ASC";
    ArticleTypeSortEnum["PublishedAtDesc"] = "PUBLISHED_AT_DESC";
    ArticleTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    ArticleTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    ArticleTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    ArticleTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    ArticleTypeSortEnum["ShopifyIdAsc"] = "SHOPIFY_ID_ASC";
    ArticleTypeSortEnum["ShopifyIdDesc"] = "SHOPIFY_ID_DESC";
    ArticleTypeSortEnum["SummaryHtmlAsc"] = "SUMMARY_HTML_ASC";
    ArticleTypeSortEnum["SummaryHtmlDesc"] = "SUMMARY_HTML_DESC";
    ArticleTypeSortEnum["TagsAsc"] = "TAGS_ASC";
    ArticleTypeSortEnum["TagsDesc"] = "TAGS_DESC";
    ArticleTypeSortEnum["TemplateSuffixAsc"] = "TEMPLATE_SUFFIX_ASC";
    ArticleTypeSortEnum["TemplateSuffixDesc"] = "TEMPLATE_SUFFIX_DESC";
    ArticleTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    ArticleTypeSortEnum["TitleDesc"] = "TITLE_DESC";
    ArticleTypeSortEnum["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    ArticleTypeSortEnum["UpdatedAtDesc"] = "UPDATED_AT_DESC";
})(ArticleTypeSortEnum = exports.ArticleTypeSortEnum || (exports.ArticleTypeSortEnum = {}));
var ArtistTypeSortEnum;
(function (ArtistTypeSortEnum) {
    ArtistTypeSortEnum["ArtworksCountAsc"] = "ARTWORKS_COUNT_ASC";
    ArtistTypeSortEnum["ArtworksCountDesc"] = "ARTWORKS_COUNT_DESC";
    ArtistTypeSortEnum["BioAsc"] = "BIO_ASC";
    ArtistTypeSortEnum["BioDesc"] = "BIO_DESC";
    ArtistTypeSortEnum["BirthAsc"] = "BIRTH_ASC";
    ArtistTypeSortEnum["BirthDesc"] = "BIRTH_DESC";
    ArtistTypeSortEnum["CollectablesCountAsc"] = "COLLECTABLES_COUNT_ASC";
    ArtistTypeSortEnum["CollectablesCountDesc"] = "COLLECTABLES_COUNT_DESC";
    ArtistTypeSortEnum["DeathAsc"] = "DEATH_ASC";
    ArtistTypeSortEnum["DeathDesc"] = "DEATH_DESC";
    ArtistTypeSortEnum["IdAsc"] = "ID_ASC";
    ArtistTypeSortEnum["IdDesc"] = "ID_DESC";
    ArtistTypeSortEnum["InstagramNameAsc"] = "INSTAGRAM_NAME_ASC";
    ArtistTypeSortEnum["InstagramNameDesc"] = "INSTAGRAM_NAME_DESC";
    ArtistTypeSortEnum["IsManualSlugAsc"] = "IS_MANUAL_SLUG_ASC";
    ArtistTypeSortEnum["IsManualSlugDesc"] = "IS_MANUAL_SLUG_DESC";
    ArtistTypeSortEnum["LastModelDateAsc"] = "LAST_MODEL_DATE_ASC";
    ArtistTypeSortEnum["LastModelDateDesc"] = "LAST_MODEL_DATE_DESC";
    ArtistTypeSortEnum["LongBioAsc"] = "LONG_BIO_ASC";
    ArtistTypeSortEnum["LongBioDesc"] = "LONG_BIO_DESC";
    ArtistTypeSortEnum["LotsCountAsc"] = "LOTS_COUNT_ASC";
    ArtistTypeSortEnum["LotsCountDesc"] = "LOTS_COUNT_DESC";
    ArtistTypeSortEnum["LotsCountUsedForTrainAsc"] = "LOTS_COUNT_USED_FOR_TRAIN_ASC";
    ArtistTypeSortEnum["LotsCountUsedForTrainDesc"] = "LOTS_COUNT_USED_FOR_TRAIN_DESC";
    ArtistTypeSortEnum["ModelVersionAsc"] = "MODEL_VERSION_ASC";
    ArtistTypeSortEnum["ModelVersionDesc"] = "MODEL_VERSION_DESC";
    ArtistTypeSortEnum["NameAsc"] = "NAME_ASC";
    ArtistTypeSortEnum["NameDesc"] = "NAME_DESC";
    ArtistTypeSortEnum["NationalityAsc"] = "NATIONALITY_ASC";
    ArtistTypeSortEnum["NationalityDesc"] = "NATIONALITY_DESC";
    ArtistTypeSortEnum["PhotoAsc"] = "PHOTO_ASC";
    ArtistTypeSortEnum["PhotoDesc"] = "PHOTO_DESC";
    ArtistTypeSortEnum["PhotoIdAsc"] = "PHOTO_ID_ASC";
    ArtistTypeSortEnum["PhotoIdDesc"] = "PHOTO_ID_DESC";
    ArtistTypeSortEnum["PrivateSalesCountAsc"] = "PRIVATE_SALES_COUNT_ASC";
    ArtistTypeSortEnum["PrivateSalesCountDesc"] = "PRIVATE_SALES_COUNT_DESC";
    ArtistTypeSortEnum["PrivateSalesCountUsedForTrainAsc"] = "PRIVATE_SALES_COUNT_USED_FOR_TRAIN_ASC";
    ArtistTypeSortEnum["PrivateSalesCountUsedForTrainDesc"] = "PRIVATE_SALES_COUNT_USED_FOR_TRAIN_DESC";
    ArtistTypeSortEnum["QualifierAsc"] = "QUALIFIER_ASC";
    ArtistTypeSortEnum["QualifierDesc"] = "QUALIFIER_DESC";
    ArtistTypeSortEnum["RecentLotsCountAsc"] = "RECENT_LOTS_COUNT_ASC";
    ArtistTypeSortEnum["RecentLotsCountDesc"] = "RECENT_LOTS_COUNT_DESC";
    ArtistTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    ArtistTypeSortEnum["SlugDesc"] = "SLUG_DESC";
    ArtistTypeSortEnum["SupportedModelVersionsAsc"] = "SUPPORTED_MODEL_VERSIONS_ASC";
    ArtistTypeSortEnum["SupportedModelVersionsDesc"] = "SUPPORTED_MODEL_VERSIONS_DESC";
    ArtistTypeSortEnum["UidAsc"] = "UID_ASC";
    ArtistTypeSortEnum["UidDesc"] = "UID_DESC";
    ArtistTypeSortEnum["ValueChartImageAsc"] = "VALUE_CHART_IMAGE_ASC";
    ArtistTypeSortEnum["ValueChartImageDesc"] = "VALUE_CHART_IMAGE_DESC";
    ArtistTypeSortEnum["ValueChartImageIdAsc"] = "VALUE_CHART_IMAGE_ID_ASC";
    ArtistTypeSortEnum["ValueChartImageIdDesc"] = "VALUE_CHART_IMAGE_ID_DESC";
    ArtistTypeSortEnum["ValueChartUrlAsc"] = "VALUE_CHART_URL_ASC";
    ArtistTypeSortEnum["ValueChartUrlDesc"] = "VALUE_CHART_URL_DESC";
})(ArtistTypeSortEnum = exports.ArtistTypeSortEnum || (exports.ArtistTypeSortEnum = {}));
var ArtworkTagTypeSortEnum;
(function (ArtworkTagTypeSortEnum) {
    ArtworkTagTypeSortEnum["CategoryAsc"] = "CATEGORY_ASC";
    ArtworkTagTypeSortEnum["CategoryDesc"] = "CATEGORY_DESC";
    ArtworkTagTypeSortEnum["IdAsc"] = "ID_ASC";
    ArtworkTagTypeSortEnum["IdDesc"] = "ID_DESC";
    ArtworkTagTypeSortEnum["NameAsc"] = "NAME_ASC";
    ArtworkTagTypeSortEnum["NameDesc"] = "NAME_DESC";
})(ArtworkTagTypeSortEnum = exports.ArtworkTagTypeSortEnum || (exports.ArtworkTagTypeSortEnum = {}));
var ArtworkTypeSortEnum;
(function (ArtworkTypeSortEnum) {
    ArtworkTypeSortEnum["CreationYearAsc"] = "CREATION_YEAR_ASC";
    ArtworkTypeSortEnum["CreationYearDesc"] = "CREATION_YEAR_DESC";
    ArtworkTypeSortEnum["CurrencyAsc"] = "CURRENCY_ASC";
    ArtworkTypeSortEnum["CurrencyDesc"] = "CURRENCY_DESC";
    ArtworkTypeSortEnum["CurrentEstimatedPriceAsc"] = "CURRENT_ESTIMATED_PRICE_ASC";
    ArtworkTypeSortEnum["CurrentEstimatedPriceDesc"] = "CURRENT_ESTIMATED_PRICE_DESC";
    ArtworkTypeSortEnum["CurrentEstimatedPricePreferredCurrencyAsc"] = "CURRENT_ESTIMATED_PRICE_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["CurrentEstimatedPricePreferredCurrencyDesc"] = "CURRENT_ESTIMATED_PRICE_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["DateLastSoldAsc"] = "DATE_LAST_SOLD_ASC";
    ArtworkTypeSortEnum["DateLastSoldDesc"] = "DATE_LAST_SOLD_DESC";
    ArtworkTypeSortEnum["DescriptionIdAsc"] = "DESCRIPTION_ID_ASC";
    ArtworkTypeSortEnum["DescriptionIdDesc"] = "DESCRIPTION_ID_DESC";
    ArtworkTypeSortEnum["DontShowLaeAsc"] = "DONT_SHOW_LAE_ASC";
    ArtworkTypeSortEnum["DontShowLaeDesc"] = "DONT_SHOW_LAE_DESC";
    ArtworkTypeSortEnum["DontUpdateLaeAsc"] = "DONT_UPDATE_LAE_ASC";
    ArtworkTypeSortEnum["DontUpdateLaeDesc"] = "DONT_UPDATE_LAE_DESC";
    ArtworkTypeSortEnum["IdAsc"] = "ID_ASC";
    ArtworkTypeSortEnum["IdDesc"] = "ID_DESC";
    ArtworkTypeSortEnum["ImageAsc"] = "IMAGE_ASC";
    ArtworkTypeSortEnum["ImageDesc"] = "IMAGE_DESC";
    ArtworkTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    ArtworkTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    ArtworkTypeSortEnum["IsManualSlugAsc"] = "IS_MANUAL_SLUG_ASC";
    ArtworkTypeSortEnum["IsManualSlugDesc"] = "IS_MANUAL_SLUG_DESC";
    ArtworkTypeSortEnum["LastCalculatedPriceCreatedAtAsc"] = "LAST_CALCULATED_PRICE_CREATED_AT_ASC";
    ArtworkTypeSortEnum["LastCalculatedPriceCreatedAtDesc"] = "LAST_CALCULATED_PRICE_CREATED_AT_DESC";
    ArtworkTypeSortEnum["LastComparablesCreatedAtAsc"] = "LAST_COMPARABLES_CREATED_AT_ASC";
    ArtworkTypeSortEnum["LastComparablesCreatedAtDesc"] = "LAST_COMPARABLES_CREATED_AT_DESC";
    ArtworkTypeSortEnum["LastHammerPriceAsc"] = "LAST_HAMMER_PRICE_ASC";
    ArtworkTypeSortEnum["LastHammerPriceDesc"] = "LAST_HAMMER_PRICE_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxPreferredCurrencyAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxPreferredCurrencyDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxUsdZeroiedAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMaxUsdZeroiedDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MAX_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinPreferredCurrencyAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinPreferredCurrencyDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinUsdZeroiedAsc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastHammerPriceEstimateMinUsdZeroiedDesc"] = "LAST_HAMMER_PRICE_ESTIMATE_MIN_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastHammerPricePreferredCurrencyAsc"] = "LAST_HAMMER_PRICE_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastHammerPricePreferredCurrencyDesc"] = "LAST_HAMMER_PRICE_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastHammerPriceUsdZeroiedAsc"] = "LAST_HAMMER_PRICE_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastHammerPriceUsdZeroiedDesc"] = "LAST_HAMMER_PRICE_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastLotStatusAsc"] = "LAST_LOT_STATUS_ASC";
    ArtworkTypeSortEnum["LastLotStatusDesc"] = "LAST_LOT_STATUS_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceAsc"] = "LAST_PREMIUM_PRICE_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceDesc"] = "LAST_PREMIUM_PRICE_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxPreferredCurrencyAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxPreferredCurrencyDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxUsdZeroiedAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMaxUsdZeroiedDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MAX_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinPreferredCurrencyAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinPreferredCurrencyDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinUsdZeroiedAsc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceEstimateMinUsdZeroiedDesc"] = "LAST_PREMIUM_PRICE_ESTIMATE_MIN_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastPremiumPricePreferredCurrencyAsc"] = "LAST_PREMIUM_PRICE_PREFERRED_CURRENCY_ASC";
    ArtworkTypeSortEnum["LastPremiumPricePreferredCurrencyDesc"] = "LAST_PREMIUM_PRICE_PREFERRED_CURRENCY_DESC";
    ArtworkTypeSortEnum["LastPremiumPriceUsdZeroiedAsc"] = "LAST_PREMIUM_PRICE_USD_ZEROIED_ASC";
    ArtworkTypeSortEnum["LastPremiumPriceUsdZeroiedDesc"] = "LAST_PREMIUM_PRICE_USD_ZEROIED_DESC";
    ArtworkTypeSortEnum["LastPriceAsc"] = "LAST_PRICE_ASC";
    ArtworkTypeSortEnum["LastPriceDesc"] = "LAST_PRICE_DESC";
    ArtworkTypeSortEnum["LastSoldAuctionHouseIdAsc"] = "LAST_SOLD_AUCTION_HOUSE_ID_ASC";
    ArtworkTypeSortEnum["LastSoldAuctionHouseIdDesc"] = "LAST_SOLD_AUCTION_HOUSE_ID_DESC";
    ArtworkTypeSortEnum["LastSoldAuctionHouseNameAsc"] = "LAST_SOLD_AUCTION_HOUSE_NAME_ASC";
    ArtworkTypeSortEnum["LastSoldAuctionHouseNameDesc"] = "LAST_SOLD_AUCTION_HOUSE_NAME_DESC";
    ArtworkTypeSortEnum["LiveArtEstimateHighAsc"] = "LIVE_ART_ESTIMATE_HIGH_ASC";
    ArtworkTypeSortEnum["LiveArtEstimateHighDesc"] = "LIVE_ART_ESTIMATE_HIGH_DESC";
    ArtworkTypeSortEnum["LiveArtEstimateLowAsc"] = "LIVE_ART_ESTIMATE_LOW_ASC";
    ArtworkTypeSortEnum["LiveArtEstimateLowDesc"] = "LIVE_ART_ESTIMATE_LOW_DESC";
    ArtworkTypeSortEnum["NameAsc"] = "NAME_ASC";
    ArtworkTypeSortEnum["NameDesc"] = "NAME_DESC";
    ArtworkTypeSortEnum["ParentIdAsc"] = "PARENT_ID_ASC";
    ArtworkTypeSortEnum["ParentIdDesc"] = "PARENT_ID_DESC";
    ArtworkTypeSortEnum["PlaceLastSoldAsc"] = "PLACE_LAST_SOLD_ASC";
    ArtworkTypeSortEnum["PlaceLastSoldDesc"] = "PLACE_LAST_SOLD_DESC";
    ArtworkTypeSortEnum["PriceMomentum_12MoAsc"] = "PRICE_MOMENTUM_12MO_ASC";
    ArtworkTypeSortEnum["PriceMomentum_12MoDesc"] = "PRICE_MOMENTUM_12MO_DESC";
    ArtworkTypeSortEnum["PriceMomentum_24MoAsc"] = "PRICE_MOMENTUM_24MO_ASC";
    ArtworkTypeSortEnum["PriceMomentum_24MoDesc"] = "PRICE_MOMENTUM_24MO_DESC";
    ArtworkTypeSortEnum["PriceMomentum_60MoAsc"] = "PRICE_MOMENTUM_60MO_ASC";
    ArtworkTypeSortEnum["PriceMomentum_60MoDesc"] = "PRICE_MOMENTUM_60MO_DESC";
    ArtworkTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    ArtworkTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    ArtworkTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    ArtworkTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    ArtworkTypeSortEnum["SearchVectorAsc"] = "SEARCH_VECTOR_ASC";
    ArtworkTypeSortEnum["SearchVectorDesc"] = "SEARCH_VECTOR_DESC";
    ArtworkTypeSortEnum["SimilarityVectorAsc"] = "SIMILARITY_VECTOR_ASC";
    ArtworkTypeSortEnum["SimilarityVectorDesc"] = "SIMILARITY_VECTOR_DESC";
    ArtworkTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    ArtworkTypeSortEnum["SlugDesc"] = "SLUG_DESC";
    ArtworkTypeSortEnum["UidAsc"] = "UID_ASC";
    ArtworkTypeSortEnum["UidDesc"] = "UID_DESC";
})(ArtworkTypeSortEnum = exports.ArtworkTypeSortEnum || (exports.ArtworkTypeSortEnum = {}));
var AttachmentTypeSortEnum;
(function (AttachmentTypeSortEnum) {
    AttachmentTypeSortEnum["IdAsc"] = "ID_ASC";
    AttachmentTypeSortEnum["IdDesc"] = "ID_DESC";
    AttachmentTypeSortEnum["S3KeyAsc"] = "S3_KEY_ASC";
    AttachmentTypeSortEnum["S3KeyDesc"] = "S3_KEY_DESC";
    AttachmentTypeSortEnum["S3PresignedUrlAsc"] = "S3_PRESIGNED_URL_ASC";
    AttachmentTypeSortEnum["S3PresignedUrlDesc"] = "S3_PRESIGNED_URL_DESC";
})(AttachmentTypeSortEnum = exports.AttachmentTypeSortEnum || (exports.AttachmentTypeSortEnum = {}));
var AuctionHouseTypeSortEnum;
(function (AuctionHouseTypeSortEnum) {
    AuctionHouseTypeSortEnum["IdAsc"] = "ID_ASC";
    AuctionHouseTypeSortEnum["IdDesc"] = "ID_DESC";
    AuctionHouseTypeSortEnum["IsLiveAsc"] = "IS_LIVE_ASC";
    AuctionHouseTypeSortEnum["IsLiveDesc"] = "IS_LIVE_DESC";
    AuctionHouseTypeSortEnum["NameAsc"] = "NAME_ASC";
    AuctionHouseTypeSortEnum["NameDesc"] = "NAME_DESC";
    AuctionHouseTypeSortEnum["PriorityOrderAsc"] = "PRIORITY_ORDER_ASC";
    AuctionHouseTypeSortEnum["PriorityOrderDesc"] = "PRIORITY_ORDER_DESC";
    AuctionHouseTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    AuctionHouseTypeSortEnum["SlugDesc"] = "SLUG_DESC";
})(AuctionHouseTypeSortEnum = exports.AuctionHouseTypeSortEnum || (exports.AuctionHouseTypeSortEnum = {}));
var BitpayInvoiceTypeSortEnum;
(function (BitpayInvoiceTypeSortEnum) {
    BitpayInvoiceTypeSortEnum["IdAsc"] = "ID_ASC";
    BitpayInvoiceTypeSortEnum["IdDesc"] = "ID_DESC";
    BitpayInvoiceTypeSortEnum["InvoiceIdAsc"] = "INVOICE_ID_ASC";
    BitpayInvoiceTypeSortEnum["InvoiceIdDesc"] = "INVOICE_ID_DESC";
    BitpayInvoiceTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    BitpayInvoiceTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    BitpayInvoiceTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    BitpayInvoiceTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    BitpayInvoiceTypeSortEnum["SaleTransactionIdAsc"] = "SALE_TRANSACTION_ID_ASC";
    BitpayInvoiceTypeSortEnum["SaleTransactionIdDesc"] = "SALE_TRANSACTION_ID_DESC";
    BitpayInvoiceTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    BitpayInvoiceTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    BitpayInvoiceTypeSortEnum["UrlAsc"] = "URL_ASC";
    BitpayInvoiceTypeSortEnum["UrlDesc"] = "URL_DESC";
})(BitpayInvoiceTypeSortEnum = exports.BitpayInvoiceTypeSortEnum || (exports.BitpayInvoiceTypeSortEnum = {}));
var BuyersPremiumRateTypeSortEnum;
(function (BuyersPremiumRateTypeSortEnum) {
    BuyersPremiumRateTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    BuyersPremiumRateTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    BuyersPremiumRateTypeSortEnum["CurrencyAsc"] = "CURRENCY_ASC";
    BuyersPremiumRateTypeSortEnum["CurrencyDesc"] = "CURRENCY_DESC";
    BuyersPremiumRateTypeSortEnum["DateEndAsc"] = "DATE_END_ASC";
    BuyersPremiumRateTypeSortEnum["DateEndDesc"] = "DATE_END_DESC";
    BuyersPremiumRateTypeSortEnum["DateStartAsc"] = "DATE_START_ASC";
    BuyersPremiumRateTypeSortEnum["DateStartDesc"] = "DATE_START_DESC";
    BuyersPremiumRateTypeSortEnum["IdAsc"] = "ID_ASC";
    BuyersPremiumRateTypeSortEnum["IdDesc"] = "ID_DESC";
    BuyersPremiumRateTypeSortEnum["IsForOnlineSalesOnlyAsc"] = "IS_FOR_ONLINE_SALES_ONLY_ASC";
    BuyersPremiumRateTypeSortEnum["IsForOnlineSalesOnlyDesc"] = "IS_FOR_ONLINE_SALES_ONLY_DESC";
    BuyersPremiumRateTypeSortEnum["LocationAsc"] = "LOCATION_ASC";
    BuyersPremiumRateTypeSortEnum["LocationDesc"] = "LOCATION_DESC";
    BuyersPremiumRateTypeSortEnum["PriceHighBoundaryAsc"] = "PRICE_HIGH_BOUNDARY_ASC";
    BuyersPremiumRateTypeSortEnum["PriceHighBoundaryDesc"] = "PRICE_HIGH_BOUNDARY_DESC";
    BuyersPremiumRateTypeSortEnum["PriceLowBoundaryAsc"] = "PRICE_LOW_BOUNDARY_ASC";
    BuyersPremiumRateTypeSortEnum["PriceLowBoundaryDesc"] = "PRICE_LOW_BOUNDARY_DESC";
    BuyersPremiumRateTypeSortEnum["RateTypeAsc"] = "RATE_TYPE_ASC";
    BuyersPremiumRateTypeSortEnum["RateTypeDesc"] = "RATE_TYPE_DESC";
    BuyersPremiumRateTypeSortEnum["ValueAsc"] = "VALUE_ASC";
    BuyersPremiumRateTypeSortEnum["ValueDesc"] = "VALUE_DESC";
})(BuyersPremiumRateTypeSortEnum = exports.BuyersPremiumRateTypeSortEnum || (exports.BuyersPremiumRateTypeSortEnum = {}));
var CategoryTypeSortEnum;
(function (CategoryTypeSortEnum) {
    CategoryTypeSortEnum["DefaultEditionTypeAsc"] = "DEFAULT_EDITION_TYPE_ASC";
    CategoryTypeSortEnum["DefaultEditionTypeDesc"] = "DEFAULT_EDITION_TYPE_DESC";
    CategoryTypeSortEnum["DefaultTypeAsc"] = "DEFAULT_TYPE_ASC";
    CategoryTypeSortEnum["DefaultTypeDesc"] = "DEFAULT_TYPE_DESC";
    CategoryTypeSortEnum["IdAsc"] = "ID_ASC";
    CategoryTypeSortEnum["IdDesc"] = "ID_DESC";
    CategoryTypeSortEnum["LabelAsc"] = "LABEL_ASC";
    CategoryTypeSortEnum["LabelDesc"] = "LABEL_DESC";
    CategoryTypeSortEnum["NameAsc"] = "NAME_ASC";
    CategoryTypeSortEnum["NameDesc"] = "NAME_DESC";
})(CategoryTypeSortEnum = exports.CategoryTypeSortEnum || (exports.CategoryTypeSortEnum = {}));
var CollectableTypeSortEnum;
(function (CollectableTypeSortEnum) {
    CollectableTypeSortEnum["AcquisitionDateAsc"] = "ACQUISITION_DATE_ASC";
    CollectableTypeSortEnum["AcquisitionDateDesc"] = "ACQUISITION_DATE_DESC";
    CollectableTypeSortEnum["ArtistAsc"] = "ARTIST_ASC";
    CollectableTypeSortEnum["ArtistDesc"] = "ARTIST_DESC";
    CollectableTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    CollectableTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    CollectableTypeSortEnum["CognitoUserIdAsc"] = "COGNITO_USER_ID_ASC";
    CollectableTypeSortEnum["CognitoUserIdDesc"] = "COGNITO_USER_ID_DESC";
    CollectableTypeSortEnum["ConditionAsc"] = "CONDITION_ASC";
    CollectableTypeSortEnum["ConditionDesc"] = "CONDITION_DESC";
    CollectableTypeSortEnum["CreationYearAsc"] = "CREATION_YEAR_ASC";
    CollectableTypeSortEnum["CreationYearDesc"] = "CREATION_YEAR_DESC";
    CollectableTypeSortEnum["CurrentEstimatedPriceAsc"] = "CURRENT_ESTIMATED_PRICE_ASC";
    CollectableTypeSortEnum["CurrentEstimatedPriceDesc"] = "CURRENT_ESTIMATED_PRICE_DESC";
    CollectableTypeSortEnum["CurrentLocationAsc"] = "CURRENT_LOCATION_ASC";
    CollectableTypeSortEnum["CurrentLocationDesc"] = "CURRENT_LOCATION_DESC";
    CollectableTypeSortEnum["DescriptionIdAsc"] = "DESCRIPTION_ID_ASC";
    CollectableTypeSortEnum["DescriptionIdDesc"] = "DESCRIPTION_ID_DESC";
    CollectableTypeSortEnum["ExhibitedAsc"] = "EXHIBITED_ASC";
    CollectableTypeSortEnum["ExhibitedDesc"] = "EXHIBITED_DESC";
    CollectableTypeSortEnum["IdAsc"] = "ID_ASC";
    CollectableTypeSortEnum["IdDesc"] = "ID_DESC";
    CollectableTypeSortEnum["ImageAsc"] = "IMAGE_ASC";
    CollectableTypeSortEnum["ImageDesc"] = "IMAGE_DESC";
    CollectableTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    CollectableTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    CollectableTypeSortEnum["IndexToMarketAsc"] = "INDEX_TO_MARKET_ASC";
    CollectableTypeSortEnum["IndexToMarketDesc"] = "INDEX_TO_MARKET_DESC";
    CollectableTypeSortEnum["IsManualSlugAsc"] = "IS_MANUAL_SLUG_ASC";
    CollectableTypeSortEnum["IsManualSlugDesc"] = "IS_MANUAL_SLUG_DESC";
    CollectableTypeSortEnum["IsSubmittedForSaleAsc"] = "IS_SUBMITTED_FOR_SALE_ASC";
    CollectableTypeSortEnum["IsSubmittedForSaleDesc"] = "IS_SUBMITTED_FOR_SALE_DESC";
    CollectableTypeSortEnum["LastRecordedSalePriceUsdAsc"] = "LAST_RECORDED_SALE_PRICE_USD_ASC";
    CollectableTypeSortEnum["LastRecordedSalePriceUsdDesc"] = "LAST_RECORDED_SALE_PRICE_USD_DESC";
    CollectableTypeSortEnum["MachineEstimatedPriceAsc"] = "MACHINE_ESTIMATED_PRICE_ASC";
    CollectableTypeSortEnum["MachineEstimatedPriceDesc"] = "MACHINE_ESTIMATED_PRICE_DESC";
    CollectableTypeSortEnum["ManualPriceCurrencyAsc"] = "MANUAL_PRICE_CURRENCY_ASC";
    CollectableTypeSortEnum["ManualPriceCurrencyDesc"] = "MANUAL_PRICE_CURRENCY_DESC";
    CollectableTypeSortEnum["ManualPriceUsdAsc"] = "MANUAL_PRICE_USD_ASC";
    CollectableTypeSortEnum["ManualPriceUsdDesc"] = "MANUAL_PRICE_USD_DESC";
    CollectableTypeSortEnum["ManualPriceValueAsc"] = "MANUAL_PRICE_VALUE_ASC";
    CollectableTypeSortEnum["ManualPriceValueDesc"] = "MANUAL_PRICE_VALUE_DESC";
    CollectableTypeSortEnum["MarkingsAsc"] = "MARKINGS_ASC";
    CollectableTypeSortEnum["MarkingsDesc"] = "MARKINGS_DESC";
    CollectableTypeSortEnum["MaterialsAsc"] = "MATERIALS_ASC";
    CollectableTypeSortEnum["MaterialsDesc"] = "MATERIALS_DESC";
    CollectableTypeSortEnum["MeasurementsDepthCmAsc"] = "MEASUREMENTS_DEPTH_CM_ASC";
    CollectableTypeSortEnum["MeasurementsDepthCmDesc"] = "MEASUREMENTS_DEPTH_CM_DESC";
    CollectableTypeSortEnum["MeasurementsDepthInchAsc"] = "MEASUREMENTS_DEPTH_INCH_ASC";
    CollectableTypeSortEnum["MeasurementsDepthInchDesc"] = "MEASUREMENTS_DEPTH_INCH_DESC";
    CollectableTypeSortEnum["MeasurementsDepthMmAsc"] = "MEASUREMENTS_DEPTH_MM_ASC";
    CollectableTypeSortEnum["MeasurementsDepthMmDesc"] = "MEASUREMENTS_DEPTH_MM_DESC";
    CollectableTypeSortEnum["MeasurementsHeightCmAsc"] = "MEASUREMENTS_HEIGHT_CM_ASC";
    CollectableTypeSortEnum["MeasurementsHeightCmDesc"] = "MEASUREMENTS_HEIGHT_CM_DESC";
    CollectableTypeSortEnum["MeasurementsHeightInchAsc"] = "MEASUREMENTS_HEIGHT_INCH_ASC";
    CollectableTypeSortEnum["MeasurementsHeightInchDesc"] = "MEASUREMENTS_HEIGHT_INCH_DESC";
    CollectableTypeSortEnum["MeasurementsHeightMmAsc"] = "MEASUREMENTS_HEIGHT_MM_ASC";
    CollectableTypeSortEnum["MeasurementsHeightMmDesc"] = "MEASUREMENTS_HEIGHT_MM_DESC";
    CollectableTypeSortEnum["MeasurementsWidthCmAsc"] = "MEASUREMENTS_WIDTH_CM_ASC";
    CollectableTypeSortEnum["MeasurementsWidthCmDesc"] = "MEASUREMENTS_WIDTH_CM_DESC";
    CollectableTypeSortEnum["MeasurementsWidthInchAsc"] = "MEASUREMENTS_WIDTH_INCH_ASC";
    CollectableTypeSortEnum["MeasurementsWidthInchDesc"] = "MEASUREMENTS_WIDTH_INCH_DESC";
    CollectableTypeSortEnum["MeasurementsWidthMmAsc"] = "MEASUREMENTS_WIDTH_MM_ASC";
    CollectableTypeSortEnum["MeasurementsWidthMmDesc"] = "MEASUREMENTS_WIDTH_MM_DESC";
    CollectableTypeSortEnum["NameAsc"] = "NAME_ASC";
    CollectableTypeSortEnum["NameDesc"] = "NAME_DESC";
    CollectableTypeSortEnum["PriceMomentum_12MoAsc"] = "PRICE_MOMENTUM_12MO_ASC";
    CollectableTypeSortEnum["PriceMomentum_12MoDesc"] = "PRICE_MOMENTUM_12MO_DESC";
    CollectableTypeSortEnum["PriceMomentum_24MoAsc"] = "PRICE_MOMENTUM_24MO_ASC";
    CollectableTypeSortEnum["PriceMomentum_24MoDesc"] = "PRICE_MOMENTUM_24MO_DESC";
    CollectableTypeSortEnum["PriceMomentum_60MoAsc"] = "PRICE_MOMENTUM_60MO_ASC";
    CollectableTypeSortEnum["PriceMomentum_60MoDesc"] = "PRICE_MOMENTUM_60MO_DESC";
    CollectableTypeSortEnum["ProvenanceAsc"] = "PROVENANCE_ASC";
    CollectableTypeSortEnum["ProvenanceDesc"] = "PROVENANCE_DESC";
    CollectableTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    CollectableTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    CollectableTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    CollectableTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    CollectableTypeSortEnum["SearchVectorAsc"] = "SEARCH_VECTOR_ASC";
    CollectableTypeSortEnum["SearchVectorDesc"] = "SEARCH_VECTOR_DESC";
    CollectableTypeSortEnum["SelectedPriceTypeAsc"] = "SELECTED_PRICE_TYPE_ASC";
    CollectableTypeSortEnum["SelectedPriceTypeDesc"] = "SELECTED_PRICE_TYPE_DESC";
    CollectableTypeSortEnum["SimilarityVectorAsc"] = "SIMILARITY_VECTOR_ASC";
    CollectableTypeSortEnum["SimilarityVectorDesc"] = "SIMILARITY_VECTOR_DESC";
    CollectableTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    CollectableTypeSortEnum["SlugDesc"] = "SLUG_DESC";
    CollectableTypeSortEnum["SuggestedArtworkAsc"] = "SUGGESTED_ARTWORK_ASC";
    CollectableTypeSortEnum["SuggestedArtworkDesc"] = "SUGGESTED_ARTWORK_DESC";
    CollectableTypeSortEnum["SyncFinancialsAsc"] = "SYNC_FINANCIALS_ASC";
    CollectableTypeSortEnum["SyncFinancialsDesc"] = "SYNC_FINANCIALS_DESC";
    CollectableTypeSortEnum["UidAsc"] = "UID_ASC";
    CollectableTypeSortEnum["UidDesc"] = "UID_DESC";
    CollectableTypeSortEnum["ValueChartImageAsc"] = "VALUE_CHART_IMAGE_ASC";
    CollectableTypeSortEnum["ValueChartImageDesc"] = "VALUE_CHART_IMAGE_DESC";
    CollectableTypeSortEnum["ValueChartImageIdAsc"] = "VALUE_CHART_IMAGE_ID_ASC";
    CollectableTypeSortEnum["ValueChartImageIdDesc"] = "VALUE_CHART_IMAGE_ID_DESC";
})(CollectableTypeSortEnum = exports.CollectableTypeSortEnum || (exports.CollectableTypeSortEnum = {}));
var CollectionTypeSortEnum;
(function (CollectionTypeSortEnum) {
    CollectionTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    CollectionTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    CollectionTypeSortEnum["IdAsc"] = "ID_ASC";
    CollectionTypeSortEnum["IdDesc"] = "ID_DESC";
    CollectionTypeSortEnum["NameAsc"] = "NAME_ASC";
    CollectionTypeSortEnum["NameDesc"] = "NAME_DESC";
    CollectionTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    CollectionTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    CollectionTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    CollectionTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
})(CollectionTypeSortEnum = exports.CollectionTypeSortEnum || (exports.CollectionTypeSortEnum = {}));
var ConditionEnum;
(function (ConditionEnum) {
    ConditionEnum["Excellent"] = "excellent";
    ConditionEnum["Fair"] = "fair";
    ConditionEnum["Poor"] = "poor";
    ConditionEnum["Pristine"] = "pristine";
    ConditionEnum["VeryGood"] = "very_good";
})(ConditionEnum = exports.ConditionEnum || (exports.ConditionEnum = {}));
var ContractTypeSortEnum;
(function (ContractTypeSortEnum) {
    ContractTypeSortEnum["AbiAsc"] = "ABI_ASC";
    ContractTypeSortEnum["AbiDesc"] = "ABI_DESC";
    ContractTypeSortEnum["AddressAsc"] = "ADDRESS_ASC";
    ContractTypeSortEnum["AddressDesc"] = "ADDRESS_DESC";
    ContractTypeSortEnum["AdminWalletAsc"] = "ADMIN_WALLET_ASC";
    ContractTypeSortEnum["AdminWalletDesc"] = "ADMIN_WALLET_DESC";
    ContractTypeSortEnum["ApplicationAsc"] = "APPLICATION_ASC";
    ContractTypeSortEnum["ApplicationDesc"] = "APPLICATION_DESC";
    ContractTypeSortEnum["ContractNameAsc"] = "CONTRACT_NAME_ASC";
    ContractTypeSortEnum["ContractNameDesc"] = "CONTRACT_NAME_DESC";
    ContractTypeSortEnum["IdAsc"] = "ID_ASC";
    ContractTypeSortEnum["IdDesc"] = "ID_DESC";
    ContractTypeSortEnum["MigrationSourceAsc"] = "MIGRATION_SOURCE_ASC";
    ContractTypeSortEnum["MigrationSourceDesc"] = "MIGRATION_SOURCE_DESC";
    ContractTypeSortEnum["NetworkIdAsc"] = "NETWORK_ID_ASC";
    ContractTypeSortEnum["NetworkIdDesc"] = "NETWORK_ID_DESC";
    ContractTypeSortEnum["PartnerIdAsc"] = "PARTNER_ID_ASC";
    ContractTypeSortEnum["PartnerIdDesc"] = "PARTNER_ID_DESC";
    ContractTypeSortEnum["SymbolAsc"] = "SYMBOL_ASC";
    ContractTypeSortEnum["SymbolDesc"] = "SYMBOL_DESC";
    ContractTypeSortEnum["VersionAsc"] = "VERSION_ASC";
    ContractTypeSortEnum["VersionDesc"] = "VERSION_DESC";
})(ContractTypeSortEnum = exports.ContractTypeSortEnum || (exports.ContractTypeSortEnum = {}));
var CuratedDropTypeSortEnum;
(function (CuratedDropTypeSortEnum) {
    CuratedDropTypeSortEnum["CreatedAtAsc"] = "CREATED_AT_ASC";
    CuratedDropTypeSortEnum["CreatedAtDesc"] = "CREATED_AT_DESC";
    CuratedDropTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    CuratedDropTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    CuratedDropTypeSortEnum["DisplayAsc"] = "DISPLAY_ASC";
    CuratedDropTypeSortEnum["DisplayDesc"] = "DISPLAY_DESC";
    CuratedDropTypeSortEnum["IdAsc"] = "ID_ASC";
    CuratedDropTypeSortEnum["IdDesc"] = "ID_DESC";
    CuratedDropTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    CuratedDropTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    CuratedDropTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    CuratedDropTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    CuratedDropTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    CuratedDropTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    CuratedDropTypeSortEnum["ShopifyIdAsc"] = "SHOPIFY_ID_ASC";
    CuratedDropTypeSortEnum["ShopifyIdDesc"] = "SHOPIFY_ID_DESC";
    CuratedDropTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    CuratedDropTypeSortEnum["TitleDesc"] = "TITLE_DESC";
})(CuratedDropTypeSortEnum = exports.CuratedDropTypeSortEnum || (exports.CuratedDropTypeSortEnum = {}));
var Currency;
(function (Currency) {
    Currency["Aed"] = "AED";
    Currency["Afn"] = "AFN";
    Currency["All"] = "ALL";
    Currency["Amd"] = "AMD";
    Currency["Ang"] = "ANG";
    Currency["Aoa"] = "AOA";
    Currency["Ars"] = "ARS";
    Currency["Ats"] = "ATS";
    Currency["Aud"] = "AUD";
    Currency["Awg"] = "AWG";
    Currency["Azn"] = "AZN";
    Currency["Bam"] = "BAM";
    Currency["Bbd"] = "BBD";
    Currency["Bdt"] = "BDT";
    Currency["Bef"] = "BEF";
    Currency["Bgn"] = "BGN";
    Currency["Bhd"] = "BHD";
    Currency["Bif"] = "BIF";
    Currency["Bmd"] = "BMD";
    Currency["Bnd"] = "BND";
    Currency["Bob"] = "BOB";
    Currency["Brl"] = "BRL";
    Currency["Bsd"] = "BSD";
    Currency["Btc"] = "BTC";
    Currency["Btn"] = "BTN";
    Currency["Bwp"] = "BWP";
    Currency["Byn"] = "BYN";
    Currency["Byr"] = "BYR";
    Currency["Bzd"] = "BZD";
    Currency["Cad"] = "CAD";
    Currency["Cdf"] = "CDF";
    Currency["Chf"] = "CHF";
    Currency["Clf"] = "CLF";
    Currency["Clp"] = "CLP";
    Currency["Cnh"] = "CNH";
    Currency["Cny"] = "CNY";
    Currency["Cop"] = "COP";
    Currency["Crc"] = "CRC";
    Currency["Cuc"] = "CUC";
    Currency["Cup"] = "CUP";
    Currency["Cve"] = "CVE";
    Currency["Cyp"] = "CYP";
    Currency["Czk"] = "CZK";
    Currency["Dem"] = "DEM";
    Currency["Djf"] = "DJF";
    Currency["Dkk"] = "DKK";
    Currency["Dop"] = "DOP";
    Currency["Dzd"] = "DZD";
    Currency["Eek"] = "EEK";
    Currency["Egp"] = "EGP";
    Currency["Ern"] = "ERN";
    Currency["Esp"] = "ESP";
    Currency["Etb"] = "ETB";
    Currency["Eth"] = "ETH";
    Currency["Eur"] = "EUR";
    Currency["Fim"] = "FIM";
    Currency["Fjd"] = "FJD";
    Currency["Fkp"] = "FKP";
    Currency["Frf"] = "FRF";
    Currency["Gbp"] = "GBP";
    Currency["Gel"] = "GEL";
    Currency["Ggp"] = "GGP";
    Currency["Ghs"] = "GHS";
    Currency["Gip"] = "GIP";
    Currency["Gmd"] = "GMD";
    Currency["Gnf"] = "GNF";
    Currency["Grd"] = "GRD";
    Currency["Gtq"] = "GTQ";
    Currency["Gyd"] = "GYD";
    Currency["Hkd"] = "HKD";
    Currency["Hnl"] = "HNL";
    Currency["Hrk"] = "HRK";
    Currency["Htg"] = "HTG";
    Currency["Huf"] = "HUF";
    Currency["Idr"] = "IDR";
    Currency["Iep"] = "IEP";
    Currency["Ils"] = "ILS";
    Currency["Imp"] = "IMP";
    Currency["Inr"] = "INR";
    Currency["Iqd"] = "IQD";
    Currency["Irr"] = "IRR";
    Currency["Isk"] = "ISK";
    Currency["Itl"] = "ITL";
    Currency["Jep"] = "JEP";
    Currency["Jmd"] = "JMD";
    Currency["Jod"] = "JOD";
    Currency["Jpy"] = "JPY";
    Currency["Kes"] = "KES";
    Currency["Kgs"] = "KGS";
    Currency["Khr"] = "KHR";
    Currency["Kmf"] = "KMF";
    Currency["Kpw"] = "KPW";
    Currency["Krw"] = "KRW";
    Currency["Kwd"] = "KWD";
    Currency["Kyd"] = "KYD";
    Currency["Kzt"] = "KZT";
    Currency["Lak"] = "LAK";
    Currency["Lbp"] = "LBP";
    Currency["Lkr"] = "LKR";
    Currency["Lrd"] = "LRD";
    Currency["Lsl"] = "LSL";
    Currency["Ltl"] = "LTL";
    Currency["Lvl"] = "LVL";
    Currency["Lyd"] = "LYD";
    Currency["Mad"] = "MAD";
    Currency["Mdl"] = "MDL";
    Currency["Mga"] = "MGA";
    Currency["Mkd"] = "MKD";
    Currency["Mmk"] = "MMK";
    Currency["Mnt"] = "MNT";
    Currency["Mop"] = "MOP";
    Currency["Mro"] = "MRO";
    Currency["Mru"] = "MRU";
    Currency["Mtl"] = "MTL";
    Currency["Mur"] = "MUR";
    Currency["Mvr"] = "MVR";
    Currency["Mwk"] = "MWK";
    Currency["Mxn"] = "MXN";
    Currency["Myr"] = "MYR";
    Currency["Mzn"] = "MZN";
    Currency["Nad"] = "NAD";
    Currency["Ngn"] = "NGN";
    Currency["Nio"] = "NIO";
    Currency["Nlg"] = "NLG";
    Currency["Nok"] = "NOK";
    Currency["Npr"] = "NPR";
    Currency["Ntd"] = "NTD";
    Currency["Nzd"] = "NZD";
    Currency["Omr"] = "OMR";
    Currency["Pab"] = "PAB";
    Currency["Pen"] = "PEN";
    Currency["Pgk"] = "PGK";
    Currency["Php"] = "PHP";
    Currency["Pkr"] = "PKR";
    Currency["Pln"] = "PLN";
    Currency["Pte"] = "PTE";
    Currency["Pyg"] = "PYG";
    Currency["Qar"] = "QAR";
    Currency["Ron"] = "RON";
    Currency["Rsd"] = "RSD";
    Currency["Rub"] = "RUB";
    Currency["Rwf"] = "RWF";
    Currency["Sar"] = "SAR";
    Currency["Sbd"] = "SBD";
    Currency["Scr"] = "SCR";
    Currency["Sdg"] = "SDG";
    Currency["Sek"] = "SEK";
    Currency["Sgd"] = "SGD";
    Currency["Shp"] = "SHP";
    Currency["Sit"] = "SIT";
    Currency["Skk"] = "SKK";
    Currency["Sll"] = "SLL";
    Currency["Sos"] = "SOS";
    Currency["Srd"] = "SRD";
    Currency["Ssp"] = "SSP";
    Currency["Std"] = "STD";
    Currency["Stn"] = "STN";
    Currency["Svc"] = "SVC";
    Currency["Syp"] = "SYP";
    Currency["Szl"] = "SZL";
    Currency["Thb"] = "THB";
    Currency["Tjs"] = "TJS";
    Currency["Tmt"] = "TMT";
    Currency["Tnd"] = "TND";
    Currency["Top"] = "TOP";
    Currency["Try"] = "TRY";
    Currency["Ttd"] = "TTD";
    Currency["Twd"] = "TWD";
    Currency["Tzs"] = "TZS";
    Currency["Uah"] = "UAH";
    Currency["Ugx"] = "UGX";
    Currency["Usd"] = "USD";
    Currency["Uyu"] = "UYU";
    Currency["Uzs"] = "UZS";
    Currency["Veb"] = "VEB";
    Currency["Vef"] = "VEF";
    Currency["Ves"] = "VES";
    Currency["Vnd"] = "VND";
    Currency["Vuv"] = "VUV";
    Currency["Wst"] = "WST";
    Currency["Xaf"] = "XAF";
    Currency["Xag"] = "XAG";
    Currency["Xau"] = "XAU";
    Currency["Xcd"] = "XCD";
    Currency["Xcp"] = "XCP";
    Currency["Xdr"] = "XDR";
    Currency["Xeu"] = "XEU";
    Currency["Xof"] = "XOF";
    Currency["Xpd"] = "XPD";
    Currency["Xpf"] = "XPF";
    Currency["Xpt"] = "XPT";
    Currency["Yer"] = "YER";
    Currency["Zar"] = "ZAR";
    Currency["Zmk"] = "ZMK";
    Currency["Zmw"] = "ZMW";
    Currency["Zwd"] = "ZWD";
    Currency["Zwl"] = "ZWL";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencyTypeSortEnum;
(function (CurrencyTypeSortEnum) {
    CurrencyTypeSortEnum["CodeAsc"] = "CODE_ASC";
    CurrencyTypeSortEnum["CodeDesc"] = "CODE_DESC";
    CurrencyTypeSortEnum["NameAsc"] = "NAME_ASC";
    CurrencyTypeSortEnum["NameDesc"] = "NAME_DESC";
    CurrencyTypeSortEnum["SymbolAsc"] = "SYMBOL_ASC";
    CurrencyTypeSortEnum["SymbolDesc"] = "SYMBOL_DESC";
    CurrencyTypeSortEnum["VisibilityAsc"] = "VISIBILITY_ASC";
    CurrencyTypeSortEnum["VisibilityDesc"] = "VISIBILITY_DESC";
})(CurrencyTypeSortEnum = exports.CurrencyTypeSortEnum || (exports.CurrencyTypeSortEnum = {}));
var DealRoomFilterStatus;
(function (DealRoomFilterStatus) {
    DealRoomFilterStatus["Active"] = "ACTIVE";
    DealRoomFilterStatus["Archive"] = "ARCHIVE";
    DealRoomFilterStatus["Purchased"] = "PURCHASED";
})(DealRoomFilterStatus = exports.DealRoomFilterStatus || (exports.DealRoomFilterStatus = {}));
var DealRoomMessageName;
(function (DealRoomMessageName) {
    DealRoomMessageName["BuyerApproved"] = "BUYER_APPROVED";
    DealRoomMessageName["BuyerConfirmInterest"] = "BUYER_CONFIRM_INTEREST";
    DealRoomMessageName["BuyerInfo"] = "BUYER_INFO";
    DealRoomMessageName["BuyerIsNotInterestedAnymore"] = "BUYER_IS_NOT_INTERESTED_ANYMORE";
    DealRoomMessageName["BuyerLeft"] = "BUYER_LEFT";
    DealRoomMessageName["BuyerRejected"] = "BUYER_REJECTED";
    DealRoomMessageName["Created"] = "CREATED";
    DealRoomMessageName["OfferAccepted"] = "OFFER_ACCEPTED";
    DealRoomMessageName["OfferDeclined"] = "OFFER_DECLINED";
    DealRoomMessageName["OfferMade"] = "OFFER_MADE";
    DealRoomMessageName["Question"] = "QUESTION";
    DealRoomMessageName["SalesAdvisorApproved"] = "SALES_ADVISOR_APPROVED";
    DealRoomMessageName["SalesAdvisorRejected"] = "SALES_ADVISOR_REJECTED";
    DealRoomMessageName["SellerLeft"] = "SELLER_LEFT";
    DealRoomMessageName["ViewingAccessApproved"] = "VIEWING_ACCESS_APPROVED";
    DealRoomMessageName["ViewingAccessDenied"] = "VIEWING_ACCESS_DENIED";
})(DealRoomMessageName = exports.DealRoomMessageName || (exports.DealRoomMessageName = {}));
var DealRoomMessageTypeSortEnum;
(function (DealRoomMessageTypeSortEnum) {
    DealRoomMessageTypeSortEnum["BuyerMarketTypeAsc"] = "BUYER_MARKET_TYPE_ASC";
    DealRoomMessageTypeSortEnum["BuyerMarketTypeDesc"] = "BUYER_MARKET_TYPE_DESC";
    DealRoomMessageTypeSortEnum["BuyerPurchasePowerAsc"] = "BUYER_PURCHASE_POWER_ASC";
    DealRoomMessageTypeSortEnum["BuyerPurchasePowerDesc"] = "BUYER_PURCHASE_POWER_DESC";
    DealRoomMessageTypeSortEnum["BuyerStatusAsc"] = "BUYER_STATUS_ASC";
    DealRoomMessageTypeSortEnum["BuyerStatusDesc"] = "BUYER_STATUS_DESC";
    DealRoomMessageTypeSortEnum["DealRoomExternalIdAsc"] = "DEAL_ROOM_EXTERNAL_ID_ASC";
    DealRoomMessageTypeSortEnum["DealRoomExternalIdDesc"] = "DEAL_ROOM_EXTERNAL_ID_DESC";
    DealRoomMessageTypeSortEnum["FromUserExternalIdAsc"] = "FROM_USER_EXTERNAL_ID_ASC";
    DealRoomMessageTypeSortEnum["FromUserExternalIdDesc"] = "FROM_USER_EXTERNAL_ID_DESC";
    DealRoomMessageTypeSortEnum["IdAsc"] = "ID_ASC";
    DealRoomMessageTypeSortEnum["IdDesc"] = "ID_DESC";
    DealRoomMessageTypeSortEnum["MessageTypeAsc"] = "MESSAGE_TYPE_ASC";
    DealRoomMessageTypeSortEnum["MessageTypeDesc"] = "MESSAGE_TYPE_DESC";
    DealRoomMessageTypeSortEnum["OfferedPriceAsc"] = "OFFERED_PRICE_ASC";
    DealRoomMessageTypeSortEnum["OfferedPriceDesc"] = "OFFERED_PRICE_DESC";
    DealRoomMessageTypeSortEnum["ProductIdAsc"] = "PRODUCT_ID_ASC";
    DealRoomMessageTypeSortEnum["ProductIdDesc"] = "PRODUCT_ID_DESC";
    DealRoomMessageTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    DealRoomMessageTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    DealRoomMessageTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    DealRoomMessageTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    DealRoomMessageTypeSortEnum["ToUserExternalIdAsc"] = "TO_USER_EXTERNAL_ID_ASC";
    DealRoomMessageTypeSortEnum["ToUserExternalIdDesc"] = "TO_USER_EXTERNAL_ID_DESC";
})(DealRoomMessageTypeSortEnum = exports.DealRoomMessageTypeSortEnum || (exports.DealRoomMessageTypeSortEnum = {}));
var DealRoomStatus;
(function (DealRoomStatus) {
    DealRoomStatus["AwaitBuyerInterestConfirmation"] = "AWAIT_BUYER_INTEREST_CONFIRMATION";
    DealRoomStatus["AwaitSalesAdvisorApproval"] = "AWAIT_SALES_ADVISOR_APPROVAL";
    DealRoomStatus["BuyerApproval"] = "BUYER_APPROVAL";
    DealRoomStatus["CloseAccessDeclined"] = "CLOSE_ACCESS_DECLINED";
    DealRoomStatus["CloseAnotherOffer"] = "CLOSE_ANOTHER_OFFER";
    DealRoomStatus["CloseNoInterest"] = "CLOSE_NO_INTEREST";
    DealRoomStatus["CloseOfferAccepted"] = "CLOSE_OFFER_ACCEPTED";
    DealRoomStatus["CloseOther"] = "CLOSE_OTHER";
    DealRoomStatus["CloseProductArchived"] = "CLOSE_PRODUCT_ARCHIVED";
    DealRoomStatus["CloseSalesAdvisorRejected"] = "CLOSE_SALES_ADVISOR_REJECTED";
    DealRoomStatus["CloseTimeLimit"] = "CLOSE_TIME_LIMIT";
    DealRoomStatus["CloseWishlistArchived"] = "CLOSE_WISHLIST_ARCHIVED";
    DealRoomStatus["CloseWithdrawn"] = "CLOSE_WITHDRAWN";
    DealRoomStatus["Completed"] = "COMPLETED";
    DealRoomStatus["ConditionReportComplete"] = "CONDITION_REPORT_COMPLETE";
    DealRoomStatus["ContractPending"] = "CONTRACT_PENDING";
    DealRoomStatus["Discovery"] = "DISCOVERY";
    DealRoomStatus["InspectionPending"] = "INSPECTION_PENDING";
    DealRoomStatus["InTransit"] = "IN_TRANSIT";
    DealRoomStatus["OfferPending"] = "OFFER_PENDING";
    DealRoomStatus["OfferRejected"] = "OFFER_REJECTED";
    DealRoomStatus["PaymentConfirmed"] = "PAYMENT_CONFIRMED";
    DealRoomStatus["PaymentRequesed"] = "PAYMENT_REQUESED";
    DealRoomStatus["PaymentSent"] = "PAYMENT_SENT";
    DealRoomStatus["SellerPaid"] = "SELLER_PAID";
    DealRoomStatus["ShipmentPending"] = "SHIPMENT_PENDING";
    DealRoomStatus["ShipmentScheduled"] = "SHIPMENT_SCHEDULED";
    DealRoomStatus["ShippingConfirmedToBuyer"] = "SHIPPING_CONFIRMED_TO_BUYER";
    DealRoomStatus["TitleReleased"] = "TITLE_RELEASED";
})(DealRoomStatus = exports.DealRoomStatus || (exports.DealRoomStatus = {}));
var DealRoomTypeSortEnum;
(function (DealRoomTypeSortEnum) {
    DealRoomTypeSortEnum["ApproveAsc"] = "APPROVE_ASC";
    DealRoomTypeSortEnum["ApproveDesc"] = "APPROVE_DESC";
    DealRoomTypeSortEnum["AttachmentS3KeyAsc"] = "ATTACHMENT_S3_KEY_ASC";
    DealRoomTypeSortEnum["AttachmentS3KeyDesc"] = "ATTACHMENT_S3_KEY_DESC";
    DealRoomTypeSortEnum["BuyerAsc"] = "BUYER_ASC";
    DealRoomTypeSortEnum["BuyerDesc"] = "BUYER_DESC";
    DealRoomTypeSortEnum["BuyerExternalIdAsc"] = "BUYER_EXTERNAL_ID_ASC";
    DealRoomTypeSortEnum["BuyerExternalIdDesc"] = "BUYER_EXTERNAL_ID_DESC";
    DealRoomTypeSortEnum["BuyerIdAsc"] = "BUYER_ID_ASC";
    DealRoomTypeSortEnum["BuyerIdDesc"] = "BUYER_ID_DESC";
    DealRoomTypeSortEnum["BuyerOrderAsc"] = "BUYER_ORDER_ASC";
    DealRoomTypeSortEnum["BuyerOrderDesc"] = "BUYER_ORDER_DESC";
    DealRoomTypeSortEnum["BuyerOrderIdAsc"] = "BUYER_ORDER_ID_ASC";
    DealRoomTypeSortEnum["BuyerOrderIdDesc"] = "BUYER_ORDER_ID_DESC";
    DealRoomTypeSortEnum["BuyerOrderNumberAsc"] = "BUYER_ORDER_NUMBER_ASC";
    DealRoomTypeSortEnum["BuyerOrderNumberDesc"] = "BUYER_ORDER_NUMBER_DESC";
    DealRoomTypeSortEnum["BuyerOrderTokenAsc"] = "BUYER_ORDER_TOKEN_ASC";
    DealRoomTypeSortEnum["BuyerOrderTokenDesc"] = "BUYER_ORDER_TOKEN_DESC";
    DealRoomTypeSortEnum["BuyerSignatureAsc"] = "BUYER_SIGNATURE_ASC";
    DealRoomTypeSortEnum["BuyerSignatureDesc"] = "BUYER_SIGNATURE_DESC";
    DealRoomTypeSortEnum["ClosedAsc"] = "CLOSED_ASC";
    DealRoomTypeSortEnum["ClosedDesc"] = "CLOSED_DESC";
    DealRoomTypeSortEnum["ContractedAsc"] = "CONTRACTED_ASC";
    DealRoomTypeSortEnum["ContractedAtAsc"] = "CONTRACTED_AT_ASC";
    DealRoomTypeSortEnum["ContractedAtDesc"] = "CONTRACTED_AT_DESC";
    DealRoomTypeSortEnum["ContractedDesc"] = "CONTRACTED_DESC";
    DealRoomTypeSortEnum["CreatedAtAsc"] = "CREATED_AT_ASC";
    DealRoomTypeSortEnum["CreatedAtDesc"] = "CREATED_AT_DESC";
    DealRoomTypeSortEnum["CrmIdAsc"] = "CRM_ID_ASC";
    DealRoomTypeSortEnum["CrmIdDesc"] = "CRM_ID_DESC";
    DealRoomTypeSortEnum["DealIdAsc"] = "DEAL_ID_ASC";
    DealRoomTypeSortEnum["DealIdDesc"] = "DEAL_ID_DESC";
    DealRoomTypeSortEnum["FilterStatusAsc"] = "FILTER_STATUS_ASC";
    DealRoomTypeSortEnum["FilterStatusDesc"] = "FILTER_STATUS_DESC";
    DealRoomTypeSortEnum["IdAsc"] = "ID_ASC";
    DealRoomTypeSortEnum["IdDesc"] = "ID_DESC";
    DealRoomTypeSortEnum["LastActionMadeByAsc"] = "LAST_ACTION_MADE_BY_ASC";
    DealRoomTypeSortEnum["LastActionMadeByDesc"] = "LAST_ACTION_MADE_BY_DESC";
    DealRoomTypeSortEnum["NotifiedAtAsc"] = "NOTIFIED_AT_ASC";
    DealRoomTypeSortEnum["NotifiedAtDesc"] = "NOTIFIED_AT_DESC";
    DealRoomTypeSortEnum["OfferedPriceAsc"] = "OFFERED_PRICE_ASC";
    DealRoomTypeSortEnum["OfferedPriceDesc"] = "OFFERED_PRICE_DESC";
    DealRoomTypeSortEnum["OptionsAsc"] = "OPTIONS_ASC";
    DealRoomTypeSortEnum["OptionsDesc"] = "OPTIONS_DESC";
    DealRoomTypeSortEnum["ProductAsc"] = "PRODUCT_ASC";
    DealRoomTypeSortEnum["ProductDesc"] = "PRODUCT_DESC";
    DealRoomTypeSortEnum["ProductIdAsc"] = "PRODUCT_ID_ASC";
    DealRoomTypeSortEnum["ProductIdDesc"] = "PRODUCT_ID_DESC";
    DealRoomTypeSortEnum["ProductShopifyIdAsc"] = "PRODUCT_SHOPIFY_ID_ASC";
    DealRoomTypeSortEnum["ProductShopifyIdDesc"] = "PRODUCT_SHOPIFY_ID_DESC";
    DealRoomTypeSortEnum["SellerAsc"] = "SELLER_ASC";
    DealRoomTypeSortEnum["SellerDesc"] = "SELLER_DESC";
    DealRoomTypeSortEnum["SellerExternalIdAsc"] = "SELLER_EXTERNAL_ID_ASC";
    DealRoomTypeSortEnum["SellerExternalIdDesc"] = "SELLER_EXTERNAL_ID_DESC";
    DealRoomTypeSortEnum["SellerIdAsc"] = "SELLER_ID_ASC";
    DealRoomTypeSortEnum["SellerIdDesc"] = "SELLER_ID_DESC";
    DealRoomTypeSortEnum["SellerOrderAsc"] = "SELLER_ORDER_ASC";
    DealRoomTypeSortEnum["SellerOrderDesc"] = "SELLER_ORDER_DESC";
    DealRoomTypeSortEnum["SellerOrderIdAsc"] = "SELLER_ORDER_ID_ASC";
    DealRoomTypeSortEnum["SellerOrderIdDesc"] = "SELLER_ORDER_ID_DESC";
    DealRoomTypeSortEnum["SellerSignatureAsc"] = "SELLER_SIGNATURE_ASC";
    DealRoomTypeSortEnum["SellerSignatureDesc"] = "SELLER_SIGNATURE_DESC";
    DealRoomTypeSortEnum["SourceAsc"] = "SOURCE_ASC";
    DealRoomTypeSortEnum["SourceDesc"] = "SOURCE_DESC";
    DealRoomTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    DealRoomTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    DealRoomTypeSortEnum["UpdatedAtAsc"] = "UPDATED_AT_ASC";
    DealRoomTypeSortEnum["UpdatedAtDesc"] = "UPDATED_AT_DESC";
    DealRoomTypeSortEnum["WishlistAsc"] = "WISHLIST_ASC";
    DealRoomTypeSortEnum["WishlistDesc"] = "WISHLIST_DESC";
    DealRoomTypeSortEnum["WishlistIdAsc"] = "WISHLIST_ID_ASC";
    DealRoomTypeSortEnum["WishlistIdDesc"] = "WISHLIST_ID_DESC";
})(DealRoomTypeSortEnum = exports.DealRoomTypeSortEnum || (exports.DealRoomTypeSortEnum = {}));
var DescriptionTypeSortEnum;
(function (DescriptionTypeSortEnum) {
    DescriptionTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    DescriptionTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    DescriptionTypeSortEnum["CategoryIdAsc"] = "CATEGORY_ID_ASC";
    DescriptionTypeSortEnum["CategoryIdDesc"] = "CATEGORY_ID_DESC";
    DescriptionTypeSortEnum["ConditionAsc"] = "CONDITION_ASC";
    DescriptionTypeSortEnum["ConditionDesc"] = "CONDITION_DESC";
    DescriptionTypeSortEnum["CreationYearAsc"] = "CREATION_YEAR_ASC";
    DescriptionTypeSortEnum["CreationYearDesc"] = "CREATION_YEAR_DESC";
    DescriptionTypeSortEnum["CreationYearRawAsc"] = "CREATION_YEAR_RAW_ASC";
    DescriptionTypeSortEnum["CreationYearRawDesc"] = "CREATION_YEAR_RAW_DESC";
    DescriptionTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    DescriptionTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    DescriptionTypeSortEnum["EditionCurrentAsc"] = "EDITION_CURRENT_ASC";
    DescriptionTypeSortEnum["EditionCurrentDesc"] = "EDITION_CURRENT_DESC";
    DescriptionTypeSortEnum["EditionSizeAsc"] = "EDITION_SIZE_ASC";
    DescriptionTypeSortEnum["EditionSizeDesc"] = "EDITION_SIZE_DESC";
    DescriptionTypeSortEnum["EditionTypeAsc"] = "EDITION_TYPE_ASC";
    DescriptionTypeSortEnum["EditionTypeDesc"] = "EDITION_TYPE_DESC";
    DescriptionTypeSortEnum["ExhibitedAsc"] = "EXHIBITED_ASC";
    DescriptionTypeSortEnum["ExhibitedDesc"] = "EXHIBITED_DESC";
    DescriptionTypeSortEnum["HasEditionsAsc"] = "HAS_EDITIONS_ASC";
    DescriptionTypeSortEnum["HasEditionsDesc"] = "HAS_EDITIONS_DESC";
    DescriptionTypeSortEnum["IdAsc"] = "ID_ASC";
    DescriptionTypeSortEnum["IdDesc"] = "ID_DESC";
    DescriptionTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    DescriptionTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    DescriptionTypeSortEnum["InscriptionAsc"] = "INSCRIPTION_ASC";
    DescriptionTypeSortEnum["InscriptionDesc"] = "INSCRIPTION_DESC";
    DescriptionTypeSortEnum["LiteratureAsc"] = "LITERATURE_ASC";
    DescriptionTypeSortEnum["LiteratureDesc"] = "LITERATURE_DESC";
    DescriptionTypeSortEnum["MarkingsAsc"] = "MARKINGS_ASC";
    DescriptionTypeSortEnum["MarkingsDesc"] = "MARKINGS_DESC";
    DescriptionTypeSortEnum["MaterialsAsc"] = "MATERIALS_ASC";
    DescriptionTypeSortEnum["MaterialsDesc"] = "MATERIALS_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthAsc"] = "MEASUREMENTS_DEPTH_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthCmAsc"] = "MEASUREMENTS_DEPTH_CM_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthCmDesc"] = "MEASUREMENTS_DEPTH_CM_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthDesc"] = "MEASUREMENTS_DEPTH_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthFtAsc"] = "MEASUREMENTS_DEPTH_FT_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthFtDesc"] = "MEASUREMENTS_DEPTH_FT_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthInchAsc"] = "MEASUREMENTS_DEPTH_INCH_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthInchDesc"] = "MEASUREMENTS_DEPTH_INCH_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthMmAsc"] = "MEASUREMENTS_DEPTH_MM_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthMmDesc"] = "MEASUREMENTS_DEPTH_MM_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthMAsc"] = "MEASUREMENTS_DEPTH_M_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthMDesc"] = "MEASUREMENTS_DEPTH_M_DESC";
    DescriptionTypeSortEnum["MeasurementsDepthUnknownAsc"] = "MEASUREMENTS_DEPTH_UNKNOWN_ASC";
    DescriptionTypeSortEnum["MeasurementsDepthUnknownDesc"] = "MEASUREMENTS_DEPTH_UNKNOWN_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterAsc"] = "MEASUREMENTS_DIAMETER_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterCmAsc"] = "MEASUREMENTS_DIAMETER_CM_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterCmDesc"] = "MEASUREMENTS_DIAMETER_CM_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterDesc"] = "MEASUREMENTS_DIAMETER_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterFtAsc"] = "MEASUREMENTS_DIAMETER_FT_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterFtDesc"] = "MEASUREMENTS_DIAMETER_FT_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterInchAsc"] = "MEASUREMENTS_DIAMETER_INCH_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterInchDesc"] = "MEASUREMENTS_DIAMETER_INCH_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterMmAsc"] = "MEASUREMENTS_DIAMETER_MM_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterMmDesc"] = "MEASUREMENTS_DIAMETER_MM_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterMAsc"] = "MEASUREMENTS_DIAMETER_M_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterMDesc"] = "MEASUREMENTS_DIAMETER_M_DESC";
    DescriptionTypeSortEnum["MeasurementsDiameterUnknownAsc"] = "MEASUREMENTS_DIAMETER_UNKNOWN_ASC";
    DescriptionTypeSortEnum["MeasurementsDiameterUnknownDesc"] = "MEASUREMENTS_DIAMETER_UNKNOWN_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightAsc"] = "MEASUREMENTS_HEIGHT_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightCmAsc"] = "MEASUREMENTS_HEIGHT_CM_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightCmDesc"] = "MEASUREMENTS_HEIGHT_CM_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightDesc"] = "MEASUREMENTS_HEIGHT_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightFtAsc"] = "MEASUREMENTS_HEIGHT_FT_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightFtDesc"] = "MEASUREMENTS_HEIGHT_FT_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightInchAsc"] = "MEASUREMENTS_HEIGHT_INCH_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightInchDesc"] = "MEASUREMENTS_HEIGHT_INCH_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightMmAsc"] = "MEASUREMENTS_HEIGHT_MM_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightMmDesc"] = "MEASUREMENTS_HEIGHT_MM_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightMAsc"] = "MEASUREMENTS_HEIGHT_M_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightMDesc"] = "MEASUREMENTS_HEIGHT_M_DESC";
    DescriptionTypeSortEnum["MeasurementsHeightUnknownAsc"] = "MEASUREMENTS_HEIGHT_UNKNOWN_ASC";
    DescriptionTypeSortEnum["MeasurementsHeightUnknownDesc"] = "MEASUREMENTS_HEIGHT_UNKNOWN_DESC";
    DescriptionTypeSortEnum["MeasurementsUnitAsc"] = "MEASUREMENTS_UNIT_ASC";
    DescriptionTypeSortEnum["MeasurementsUnitDesc"] = "MEASUREMENTS_UNIT_DESC";
    DescriptionTypeSortEnum["MeasurementsWeightAsc"] = "MEASUREMENTS_WEIGHT_ASC";
    DescriptionTypeSortEnum["MeasurementsWeightDesc"] = "MEASUREMENTS_WEIGHT_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthAsc"] = "MEASUREMENTS_WIDTH_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthCmAsc"] = "MEASUREMENTS_WIDTH_CM_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthCmDesc"] = "MEASUREMENTS_WIDTH_CM_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthDesc"] = "MEASUREMENTS_WIDTH_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthFtAsc"] = "MEASUREMENTS_WIDTH_FT_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthFtDesc"] = "MEASUREMENTS_WIDTH_FT_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthInchAsc"] = "MEASUREMENTS_WIDTH_INCH_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthInchDesc"] = "MEASUREMENTS_WIDTH_INCH_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthMmAsc"] = "MEASUREMENTS_WIDTH_MM_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthMmDesc"] = "MEASUREMENTS_WIDTH_MM_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthMAsc"] = "MEASUREMENTS_WIDTH_M_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthMDesc"] = "MEASUREMENTS_WIDTH_M_DESC";
    DescriptionTypeSortEnum["MeasurementsWidthUnknownAsc"] = "MEASUREMENTS_WIDTH_UNKNOWN_ASC";
    DescriptionTypeSortEnum["MeasurementsWidthUnknownDesc"] = "MEASUREMENTS_WIDTH_UNKNOWN_DESC";
    DescriptionTypeSortEnum["NameAsc"] = "NAME_ASC";
    DescriptionTypeSortEnum["NameDesc"] = "NAME_DESC";
    DescriptionTypeSortEnum["NotesAsc"] = "NOTES_ASC";
    DescriptionTypeSortEnum["NotesDesc"] = "NOTES_DESC";
    DescriptionTypeSortEnum["ProvenanceAsc"] = "PROVENANCE_ASC";
    DescriptionTypeSortEnum["ProvenanceDesc"] = "PROVENANCE_DESC";
    DescriptionTypeSortEnum["SheetHeightAsc"] = "SHEET_HEIGHT_ASC";
    DescriptionTypeSortEnum["SheetHeightCmAsc"] = "SHEET_HEIGHT_CM_ASC";
    DescriptionTypeSortEnum["SheetHeightCmDesc"] = "SHEET_HEIGHT_CM_DESC";
    DescriptionTypeSortEnum["SheetHeightDesc"] = "SHEET_HEIGHT_DESC";
    DescriptionTypeSortEnum["SheetHeightFtAsc"] = "SHEET_HEIGHT_FT_ASC";
    DescriptionTypeSortEnum["SheetHeightFtDesc"] = "SHEET_HEIGHT_FT_DESC";
    DescriptionTypeSortEnum["SheetHeightInchAsc"] = "SHEET_HEIGHT_INCH_ASC";
    DescriptionTypeSortEnum["SheetHeightInchDesc"] = "SHEET_HEIGHT_INCH_DESC";
    DescriptionTypeSortEnum["SheetHeightMmAsc"] = "SHEET_HEIGHT_MM_ASC";
    DescriptionTypeSortEnum["SheetHeightMmDesc"] = "SHEET_HEIGHT_MM_DESC";
    DescriptionTypeSortEnum["SheetHeightMAsc"] = "SHEET_HEIGHT_M_ASC";
    DescriptionTypeSortEnum["SheetHeightMDesc"] = "SHEET_HEIGHT_M_DESC";
    DescriptionTypeSortEnum["SheetHeightUnknownAsc"] = "SHEET_HEIGHT_UNKNOWN_ASC";
    DescriptionTypeSortEnum["SheetHeightUnknownDesc"] = "SHEET_HEIGHT_UNKNOWN_DESC";
    DescriptionTypeSortEnum["SheetUnitAsc"] = "SHEET_UNIT_ASC";
    DescriptionTypeSortEnum["SheetUnitDesc"] = "SHEET_UNIT_DESC";
    DescriptionTypeSortEnum["SheetWidthAsc"] = "SHEET_WIDTH_ASC";
    DescriptionTypeSortEnum["SheetWidthCmAsc"] = "SHEET_WIDTH_CM_ASC";
    DescriptionTypeSortEnum["SheetWidthCmDesc"] = "SHEET_WIDTH_CM_DESC";
    DescriptionTypeSortEnum["SheetWidthDesc"] = "SHEET_WIDTH_DESC";
    DescriptionTypeSortEnum["SheetWidthFtAsc"] = "SHEET_WIDTH_FT_ASC";
    DescriptionTypeSortEnum["SheetWidthFtDesc"] = "SHEET_WIDTH_FT_DESC";
    DescriptionTypeSortEnum["SheetWidthInchAsc"] = "SHEET_WIDTH_INCH_ASC";
    DescriptionTypeSortEnum["SheetWidthInchDesc"] = "SHEET_WIDTH_INCH_DESC";
    DescriptionTypeSortEnum["SheetWidthMmAsc"] = "SHEET_WIDTH_MM_ASC";
    DescriptionTypeSortEnum["SheetWidthMmDesc"] = "SHEET_WIDTH_MM_DESC";
    DescriptionTypeSortEnum["SheetWidthMAsc"] = "SHEET_WIDTH_M_ASC";
    DescriptionTypeSortEnum["SheetWidthMDesc"] = "SHEET_WIDTH_M_DESC";
    DescriptionTypeSortEnum["SheetWidthUnknownAsc"] = "SHEET_WIDTH_UNKNOWN_ASC";
    DescriptionTypeSortEnum["SheetWidthUnknownDesc"] = "SHEET_WIDTH_UNKNOWN_DESC";
    DescriptionTypeSortEnum["SignaturesAsc"] = "SIGNATURES_ASC";
    DescriptionTypeSortEnum["SignaturesDesc"] = "SIGNATURES_DESC";
    DescriptionTypeSortEnum["SizeNotesAsc"] = "SIZE_NOTES_ASC";
    DescriptionTypeSortEnum["SizeNotesDesc"] = "SIZE_NOTES_DESC";
    DescriptionTypeSortEnum["ValueChartImageIdAsc"] = "VALUE_CHART_IMAGE_ID_ASC";
    DescriptionTypeSortEnum["ValueChartImageIdDesc"] = "VALUE_CHART_IMAGE_ID_DESC";
})(DescriptionTypeSortEnum = exports.DescriptionTypeSortEnum || (exports.DescriptionTypeSortEnum = {}));
var EventTypeSortEnum;
(function (EventTypeSortEnum) {
    EventTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    EventTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    EventTypeSortEnum["ArtworkIdAsc"] = "ARTWORK_ID_ASC";
    EventTypeSortEnum["ArtworkIdDesc"] = "ARTWORK_ID_DESC";
    EventTypeSortEnum["DateAsc"] = "DATE_ASC";
    EventTypeSortEnum["DateDesc"] = "DATE_DESC";
    EventTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    EventTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    EventTypeSortEnum["IdAsc"] = "ID_ASC";
    EventTypeSortEnum["IdDesc"] = "ID_DESC";
    EventTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    EventTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    EventTypeSortEnum["ImageUrlAsc"] = "IMAGE_URL_ASC";
    EventTypeSortEnum["ImageUrlDesc"] = "IMAGE_URL_DESC";
    EventTypeSortEnum["NormalizedDescriptionAsc"] = "NORMALIZED_DESCRIPTION_ASC";
    EventTypeSortEnum["NormalizedDescriptionDesc"] = "NORMALIZED_DESCRIPTION_DESC";
    EventTypeSortEnum["ParamsAsc"] = "PARAMS_ASC";
    EventTypeSortEnum["ParamsDesc"] = "PARAMS_DESC";
    EventTypeSortEnum["RawLotIdAsc"] = "RAW_LOT_ID_ASC";
    EventTypeSortEnum["RawLotIdDesc"] = "RAW_LOT_ID_DESC";
    EventTypeSortEnum["TypeAsc"] = "TYPE_ASC";
    EventTypeSortEnum["TypeDesc"] = "TYPE_DESC";
    EventTypeSortEnum["VisibilityAsc"] = "VISIBILITY_ASC";
    EventTypeSortEnum["VisibilityDesc"] = "VISIBILITY_DESC";
    EventTypeSortEnum["YearAsc"] = "YEAR_ASC";
    EventTypeSortEnum["YearDesc"] = "YEAR_DESC";
})(EventTypeSortEnum = exports.EventTypeSortEnum || (exports.EventTypeSortEnum = {}));
var ImageTypeSortEnum;
(function (ImageTypeSortEnum) {
    ImageTypeSortEnum["IdAsc"] = "ID_ASC";
    ImageTypeSortEnum["IdDesc"] = "ID_DESC";
    ImageTypeSortEnum["MediumS3PresignedUrlAsc"] = "MEDIUM_S3_PRESIGNED_URL_ASC";
    ImageTypeSortEnum["MediumS3PresignedUrlDesc"] = "MEDIUM_S3_PRESIGNED_URL_DESC";
    ImageTypeSortEnum["S3KeyAsc"] = "S3_KEY_ASC";
    ImageTypeSortEnum["S3KeyDesc"] = "S3_KEY_DESC";
    ImageTypeSortEnum["ThumbnailS3PresignedUrlAsc"] = "THUMBNAIL_S3_PRESIGNED_URL_ASC";
    ImageTypeSortEnum["ThumbnailS3PresignedUrlDesc"] = "THUMBNAIL_S3_PRESIGNED_URL_DESC";
})(ImageTypeSortEnum = exports.ImageTypeSortEnum || (exports.ImageTypeSortEnum = {}));
var InstagramAccountTypeSortEnum;
(function (InstagramAccountTypeSortEnum) {
    InstagramAccountTypeSortEnum["ArtistAsc"] = "ARTIST_ASC";
    InstagramAccountTypeSortEnum["ArtistDesc"] = "ARTIST_DESC";
    InstagramAccountTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    InstagramAccountTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    InstagramAccountTypeSortEnum["IdAsc"] = "ID_ASC";
    InstagramAccountTypeSortEnum["IdDesc"] = "ID_DESC";
    InstagramAccountTypeSortEnum["InstagramHandleAsc"] = "INSTAGRAM_HANDLE_ASC";
    InstagramAccountTypeSortEnum["InstagramHandleDesc"] = "INSTAGRAM_HANDLE_DESC";
    InstagramAccountTypeSortEnum["IsParsedAsc"] = "IS_PARSED_ASC";
    InstagramAccountTypeSortEnum["IsParsedDesc"] = "IS_PARSED_DESC";
})(InstagramAccountTypeSortEnum = exports.InstagramAccountTypeSortEnum || (exports.InstagramAccountTypeSortEnum = {}));
var LotTypeSortEnum;
(function (LotTypeSortEnum) {
    LotTypeSortEnum["ArtworkIdAsc"] = "ARTWORK_ID_ASC";
    LotTypeSortEnum["ArtworkIdDesc"] = "ARTWORK_ID_DESC";
    LotTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    LotTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    LotTypeSortEnum["AuctionHouseNameAsc"] = "AUCTION_HOUSE_NAME_ASC";
    LotTypeSortEnum["AuctionHouseNameDesc"] = "AUCTION_HOUSE_NAME_DESC";
    LotTypeSortEnum["AuctionStartDateAsc"] = "AUCTION_START_DATE_ASC";
    LotTypeSortEnum["AuctionStartDateDesc"] = "AUCTION_START_DATE_DESC";
    LotTypeSortEnum["CatalogNotesAsc"] = "CATALOG_NOTES_ASC";
    LotTypeSortEnum["CatalogNotesDesc"] = "CATALOG_NOTES_DESC";
    LotTypeSortEnum["CurrencyAsc"] = "CURRENCY_ASC";
    LotTypeSortEnum["CurrencyDesc"] = "CURRENCY_DESC";
    LotTypeSortEnum["DescriptionIdAsc"] = "DESCRIPTION_ID_ASC";
    LotTypeSortEnum["DescriptionIdDesc"] = "DESCRIPTION_ID_DESC";
    LotTypeSortEnum["HammerPriceEstimateMaxAsc"] = "HAMMER_PRICE_ESTIMATE_MAX_ASC";
    LotTypeSortEnum["HammerPriceEstimateMaxDesc"] = "HAMMER_PRICE_ESTIMATE_MAX_DESC";
    LotTypeSortEnum["HammerPriceEstimateMaxPreferredCurrencyAsc"] = "HAMMER_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_ASC";
    LotTypeSortEnum["HammerPriceEstimateMaxPreferredCurrencyDesc"] = "HAMMER_PRICE_ESTIMATE_MAX_PREFERRED_CURRENCY_DESC";
    LotTypeSortEnum["HammerPriceEstimateMaxUsdZeroiedAsc"] = "HAMMER_PRICE_ESTIMATE_MAX_USD_ZEROIED_ASC";
    LotTypeSortEnum["HammerPriceEstimateMaxUsdZeroiedDesc"] = "HAMMER_PRICE_ESTIMATE_MAX_USD_ZEROIED_DESC";
    LotTypeSortEnum["HammerPriceEstimateMinAsc"] = "HAMMER_PRICE_ESTIMATE_MIN_ASC";
    LotTypeSortEnum["HammerPriceEstimateMinDesc"] = "HAMMER_PRICE_ESTIMATE_MIN_DESC";
    LotTypeSortEnum["HammerPriceEstimateMinPreferredCurrencyAsc"] = "HAMMER_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_ASC";
    LotTypeSortEnum["HammerPriceEstimateMinPreferredCurrencyDesc"] = "HAMMER_PRICE_ESTIMATE_MIN_PREFERRED_CURRENCY_DESC";
    LotTypeSortEnum["HammerPriceEstimateMinUsdZeroiedAsc"] = "HAMMER_PRICE_ESTIMATE_MIN_USD_ZEROIED_ASC";
    LotTypeSortEnum["HammerPriceEstimateMinUsdZeroiedDesc"] = "HAMMER_PRICE_ESTIMATE_MIN_USD_ZEROIED_DESC";
    LotTypeSortEnum["HammerPricePreferredCurrencyAsc"] = "HAMMER_PRICE_PREFERRED_CURRENCY_ASC";
    LotTypeSortEnum["HammerPricePreferredCurrencyDesc"] = "HAMMER_PRICE_PREFERRED_CURRENCY_DESC";
    LotTypeSortEnum["HammerPriceSoldAsc"] = "HAMMER_PRICE_SOLD_ASC";
    LotTypeSortEnum["HammerPriceSoldDesc"] = "HAMMER_PRICE_SOLD_DESC";
    LotTypeSortEnum["HammerPriceUsdZeroiedAsc"] = "HAMMER_PRICE_USD_ZEROIED_ASC";
    LotTypeSortEnum["HammerPriceUsdZeroiedDesc"] = "HAMMER_PRICE_USD_ZEROIED_DESC";
    LotTypeSortEnum["HouseGuaranteedMarkAsc"] = "HOUSE_GUARANTEED_MARK_ASC";
    LotTypeSortEnum["HouseGuaranteedMarkDesc"] = "HOUSE_GUARANTEED_MARK_DESC";
    LotTypeSortEnum["IdAsc"] = "ID_ASC";
    LotTypeSortEnum["IdDesc"] = "ID_DESC";
    LotTypeSortEnum["ImageAsc"] = "IMAGE_ASC";
    LotTypeSortEnum["ImageDesc"] = "IMAGE_DESC";
    LotTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    LotTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    LotTypeSortEnum["IsEstimateUponRequestAsc"] = "IS_ESTIMATE_UPON_REQUEST_ASC";
    LotTypeSortEnum["IsEstimateUponRequestDesc"] = "IS_ESTIMATE_UPON_REQUEST_DESC";
    LotTypeSortEnum["IsMultipleObjectsAsc"] = "IS_MULTIPLE_OBJECTS_ASC";
    LotTypeSortEnum["IsMultipleObjectsDesc"] = "IS_MULTIPLE_OBJECTS_DESC";
    LotTypeSortEnum["IsTopAsc"] = "IS_TOP_ASC";
    LotTypeSortEnum["IsTopDesc"] = "IS_TOP_DESC";
    LotTypeSortEnum["LastBidAsc"] = "LAST_BID_ASC";
    LotTypeSortEnum["LastBidDesc"] = "LAST_BID_DESC";
    LotTypeSortEnum["LastBidPreferredCurrencyAsc"] = "LAST_BID_PREFERRED_CURRENCY_ASC";
    LotTypeSortEnum["LastBidPreferredCurrencyDesc"] = "LAST_BID_PREFERRED_CURRENCY_DESC";
    LotTypeSortEnum["LastBidUsdAsc"] = "LAST_BID_USD_ASC";
    LotTypeSortEnum["LastBidUsdDesc"] = "LAST_BID_USD_DESC";
    LotTypeSortEnum["LotNumAlphaAsc"] = "LOT_NUM_ALPHA_ASC";
    LotTypeSortEnum["LotNumAlphaDesc"] = "LOT_NUM_ALPHA_DESC";
    LotTypeSortEnum["LotNumAsc"] = "LOT_NUM_ASC";
    LotTypeSortEnum["LotNumDesc"] = "LOT_NUM_DESC";
    LotTypeSortEnum["LotNumNumberAsc"] = "LOT_NUM_NUMBER_ASC";
    LotTypeSortEnum["LotNumNumberDesc"] = "LOT_NUM_NUMBER_DESC";
    LotTypeSortEnum["LotUrlAsc"] = "LOT_URL_ASC";
    LotTypeSortEnum["LotUrlDesc"] = "LOT_URL_DESC";
    LotTypeSortEnum["NumberAsc"] = "NUMBER_ASC";
    LotTypeSortEnum["NumberDesc"] = "NUMBER_DESC";
    LotTypeSortEnum["PremiumCheckAsc"] = "PREMIUM_CHECK_ASC";
    LotTypeSortEnum["PremiumCheckDesc"] = "PREMIUM_CHECK_DESC";
    LotTypeSortEnum["PremiumPricePreferredCurrencyAsc"] = "PREMIUM_PRICE_PREFERRED_CURRENCY_ASC";
    LotTypeSortEnum["PremiumPricePreferredCurrencyDesc"] = "PREMIUM_PRICE_PREFERRED_CURRENCY_DESC";
    LotTypeSortEnum["PremiumPriceSoldAsc"] = "PREMIUM_PRICE_SOLD_ASC";
    LotTypeSortEnum["PremiumPriceSoldDesc"] = "PREMIUM_PRICE_SOLD_DESC";
    LotTypeSortEnum["PremiumPriceUsdZeroiedAsc"] = "PREMIUM_PRICE_USD_ZEROIED_ASC";
    LotTypeSortEnum["PremiumPriceUsdZeroiedDesc"] = "PREMIUM_PRICE_USD_ZEROIED_DESC";
    LotTypeSortEnum["PriceKindAsc"] = "PRICE_KIND_ASC";
    LotTypeSortEnum["PriceKindDesc"] = "PRICE_KIND_DESC";
    LotTypeSortEnum["RawLotIdAsc"] = "RAW_LOT_ID_ASC";
    LotTypeSortEnum["RawLotIdDesc"] = "RAW_LOT_ID_DESC";
    LotTypeSortEnum["ReserveMarkAsc"] = "RESERVE_MARK_ASC";
    LotTypeSortEnum["ReserveMarkDesc"] = "RESERVE_MARK_DESC";
    LotTypeSortEnum["SaleIdAsc"] = "SALE_ID_ASC";
    LotTypeSortEnum["SaleIdDesc"] = "SALE_ID_DESC";
    LotTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    LotTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    LotTypeSortEnum["ThirdPartyMarkAsc"] = "THIRD_PARTY_MARK_ASC";
    LotTypeSortEnum["ThirdPartyMarkDesc"] = "THIRD_PARTY_MARK_DESC";
})(LotTypeSortEnum = exports.LotTypeSortEnum || (exports.LotTypeSortEnum = {}));
var MarketCollectionTypeSortEnum;
(function (MarketCollectionTypeSortEnum) {
    MarketCollectionTypeSortEnum["CoverImageIdAsc"] = "COVER_IMAGE_ID_ASC";
    MarketCollectionTypeSortEnum["CoverImageIdDesc"] = "COVER_IMAGE_ID_DESC";
    MarketCollectionTypeSortEnum["DefaultSortAsc"] = "DEFAULT_SORT_ASC";
    MarketCollectionTypeSortEnum["DefaultSortDesc"] = "DEFAULT_SORT_DESC";
    MarketCollectionTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    MarketCollectionTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    MarketCollectionTypeSortEnum["FilterTagAsc"] = "FILTER_TAG_ASC";
    MarketCollectionTypeSortEnum["FilterTagDesc"] = "FILTER_TAG_DESC";
    MarketCollectionTypeSortEnum["FilterTagIdAsc"] = "FILTER_TAG_ID_ASC";
    MarketCollectionTypeSortEnum["FilterTagIdDesc"] = "FILTER_TAG_ID_DESC";
    MarketCollectionTypeSortEnum["IdAsc"] = "ID_ASC";
    MarketCollectionTypeSortEnum["IdDesc"] = "ID_DESC";
    MarketCollectionTypeSortEnum["IsDynamicAsc"] = "IS_DYNAMIC_ASC";
    MarketCollectionTypeSortEnum["IsDynamicDesc"] = "IS_DYNAMIC_DESC";
    MarketCollectionTypeSortEnum["IsPublishedAsc"] = "IS_PUBLISHED_ASC";
    MarketCollectionTypeSortEnum["IsPublishedDesc"] = "IS_PUBLISHED_DESC";
    MarketCollectionTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    MarketCollectionTypeSortEnum["SlugDesc"] = "SLUG_DESC";
    MarketCollectionTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    MarketCollectionTypeSortEnum["TitleDesc"] = "TITLE_DESC";
})(MarketCollectionTypeSortEnum = exports.MarketCollectionTypeSortEnum || (exports.MarketCollectionTypeSortEnum = {}));
var MarketProductTypeSortEnum;
(function (MarketProductTypeSortEnum) {
    MarketProductTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    MarketProductTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    MarketProductTypeSortEnum["ArtistUidAsc"] = "ARTIST_UID_ASC";
    MarketProductTypeSortEnum["ArtistUidDesc"] = "ARTIST_UID_DESC";
    MarketProductTypeSortEnum["CategoryAsc"] = "CATEGORY_ASC";
    MarketProductTypeSortEnum["CategoryDesc"] = "CATEGORY_DESC";
    MarketProductTypeSortEnum["CreationYearAsc"] = "CREATION_YEAR_ASC";
    MarketProductTypeSortEnum["CreationYearDesc"] = "CREATION_YEAR_DESC";
    MarketProductTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    MarketProductTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    MarketProductTypeSortEnum["IdAsc"] = "ID_ASC";
    MarketProductTypeSortEnum["IdDesc"] = "ID_DESC";
    MarketProductTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    MarketProductTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthAsc"] = "MEASUREMENTS_DEPTH_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthCmAsc"] = "MEASUREMENTS_DEPTH_CM_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthCmDesc"] = "MEASUREMENTS_DEPTH_CM_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthDesc"] = "MEASUREMENTS_DEPTH_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthFtAsc"] = "MEASUREMENTS_DEPTH_FT_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthFtDesc"] = "MEASUREMENTS_DEPTH_FT_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthInchAsc"] = "MEASUREMENTS_DEPTH_INCH_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthInchDesc"] = "MEASUREMENTS_DEPTH_INCH_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthMmAsc"] = "MEASUREMENTS_DEPTH_MM_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthMmDesc"] = "MEASUREMENTS_DEPTH_MM_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthMAsc"] = "MEASUREMENTS_DEPTH_M_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthMDesc"] = "MEASUREMENTS_DEPTH_M_DESC";
    MarketProductTypeSortEnum["MeasurementsDepthUnknownAsc"] = "MEASUREMENTS_DEPTH_UNKNOWN_ASC";
    MarketProductTypeSortEnum["MeasurementsDepthUnknownDesc"] = "MEASUREMENTS_DEPTH_UNKNOWN_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightAsc"] = "MEASUREMENTS_HEIGHT_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightCmAsc"] = "MEASUREMENTS_HEIGHT_CM_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightCmDesc"] = "MEASUREMENTS_HEIGHT_CM_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightDesc"] = "MEASUREMENTS_HEIGHT_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightFtAsc"] = "MEASUREMENTS_HEIGHT_FT_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightFtDesc"] = "MEASUREMENTS_HEIGHT_FT_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightInchAsc"] = "MEASUREMENTS_HEIGHT_INCH_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightInchDesc"] = "MEASUREMENTS_HEIGHT_INCH_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightMmAsc"] = "MEASUREMENTS_HEIGHT_MM_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightMmDesc"] = "MEASUREMENTS_HEIGHT_MM_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightMAsc"] = "MEASUREMENTS_HEIGHT_M_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightMDesc"] = "MEASUREMENTS_HEIGHT_M_DESC";
    MarketProductTypeSortEnum["MeasurementsHeightUnknownAsc"] = "MEASUREMENTS_HEIGHT_UNKNOWN_ASC";
    MarketProductTypeSortEnum["MeasurementsHeightUnknownDesc"] = "MEASUREMENTS_HEIGHT_UNKNOWN_DESC";
    MarketProductTypeSortEnum["MeasurementsUnitAsc"] = "MEASUREMENTS_UNIT_ASC";
    MarketProductTypeSortEnum["MeasurementsUnitDesc"] = "MEASUREMENTS_UNIT_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthAsc"] = "MEASUREMENTS_WIDTH_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthCmAsc"] = "MEASUREMENTS_WIDTH_CM_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthCmDesc"] = "MEASUREMENTS_WIDTH_CM_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthDesc"] = "MEASUREMENTS_WIDTH_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthFtAsc"] = "MEASUREMENTS_WIDTH_FT_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthFtDesc"] = "MEASUREMENTS_WIDTH_FT_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthInchAsc"] = "MEASUREMENTS_WIDTH_INCH_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthInchDesc"] = "MEASUREMENTS_WIDTH_INCH_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthMmAsc"] = "MEASUREMENTS_WIDTH_MM_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthMmDesc"] = "MEASUREMENTS_WIDTH_MM_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthMAsc"] = "MEASUREMENTS_WIDTH_M_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthMDesc"] = "MEASUREMENTS_WIDTH_M_DESC";
    MarketProductTypeSortEnum["MeasurementsWidthUnknownAsc"] = "MEASUREMENTS_WIDTH_UNKNOWN_ASC";
    MarketProductTypeSortEnum["MeasurementsWidthUnknownDesc"] = "MEASUREMENTS_WIDTH_UNKNOWN_DESC";
    MarketProductTypeSortEnum["PriceCurrencyAsc"] = "PRICE_CURRENCY_ASC";
    MarketProductTypeSortEnum["PriceCurrencyDesc"] = "PRICE_CURRENCY_DESC";
    MarketProductTypeSortEnum["PriceMaxAsc"] = "PRICE_MAX_ASC";
    MarketProductTypeSortEnum["PriceMaxDesc"] = "PRICE_MAX_DESC";
    MarketProductTypeSortEnum["PriceMaxPreferredCurrencyAsc"] = "PRICE_MAX_PREFERRED_CURRENCY_ASC";
    MarketProductTypeSortEnum["PriceMaxPreferredCurrencyDesc"] = "PRICE_MAX_PREFERRED_CURRENCY_DESC";
    MarketProductTypeSortEnum["PriceMinAsc"] = "PRICE_MIN_ASC";
    MarketProductTypeSortEnum["PriceMinDesc"] = "PRICE_MIN_DESC";
    MarketProductTypeSortEnum["PriceMinPreferredCurrencyAsc"] = "PRICE_MIN_PREFERRED_CURRENCY_ASC";
    MarketProductTypeSortEnum["PriceMinPreferredCurrencyDesc"] = "PRICE_MIN_PREFERRED_CURRENCY_DESC";
    MarketProductTypeSortEnum["PrivateStatusAsc"] = "PRIVATE_STATUS_ASC";
    MarketProductTypeSortEnum["PrivateStatusDesc"] = "PRIVATE_STATUS_DESC";
    MarketProductTypeSortEnum["ShopifyIdAsc"] = "SHOPIFY_ID_ASC";
    MarketProductTypeSortEnum["ShopifyIdDesc"] = "SHOPIFY_ID_DESC";
    MarketProductTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    MarketProductTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    MarketProductTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    MarketProductTypeSortEnum["TitleDesc"] = "TITLE_DESC";
})(MarketProductTypeSortEnum = exports.MarketProductTypeSortEnum || (exports.MarketProductTypeSortEnum = {}));
var NftCurrency;
(function (NftCurrency) {
    NftCurrency["Eth"] = "ETH";
    NftCurrency["Usd"] = "USD";
})(NftCurrency = exports.NftCurrency || (exports.NftCurrency = {}));
var NftNetworkTypeSortEnum;
(function (NftNetworkTypeSortEnum) {
    NftNetworkTypeSortEnum["ChainIdAsc"] = "CHAIN_ID_ASC";
    NftNetworkTypeSortEnum["ChainIdDesc"] = "CHAIN_ID_DESC";
    NftNetworkTypeSortEnum["IdAsc"] = "ID_ASC";
    NftNetworkTypeSortEnum["IdDesc"] = "ID_DESC";
    NftNetworkTypeSortEnum["NameAsc"] = "NAME_ASC";
    NftNetworkTypeSortEnum["NameDesc"] = "NAME_DESC";
    NftNetworkTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    NftNetworkTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    NftNetworkTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    NftNetworkTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    NftNetworkTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    NftNetworkTypeSortEnum["SlugDesc"] = "SLUG_DESC";
})(NftNetworkTypeSortEnum = exports.NftNetworkTypeSortEnum || (exports.NftNetworkTypeSortEnum = {}));
var NftPartnerTypeSortEnum;
(function (NftPartnerTypeSortEnum) {
    NftPartnerTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    NftPartnerTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    NftPartnerTypeSortEnum["IdAsc"] = "ID_ASC";
    NftPartnerTypeSortEnum["IdDesc"] = "ID_DESC";
    NftPartnerTypeSortEnum["NameAsc"] = "NAME_ASC";
    NftPartnerTypeSortEnum["NameDesc"] = "NAME_DESC";
})(NftPartnerTypeSortEnum = exports.NftPartnerTypeSortEnum || (exports.NftPartnerTypeSortEnum = {}));
var NftSaleTypeSortEnum;
(function (NftSaleTypeSortEnum) {
    NftSaleTypeSortEnum["CurrentTransactionIdAsc"] = "CURRENT_TRANSACTION_ID_ASC";
    NftSaleTypeSortEnum["CurrentTransactionIdDesc"] = "CURRENT_TRANSACTION_ID_DESC";
    NftSaleTypeSortEnum["FromWalletAsc"] = "FROM_WALLET_ASC";
    NftSaleTypeSortEnum["FromWalletDesc"] = "FROM_WALLET_DESC";
    NftSaleTypeSortEnum["IdAsc"] = "ID_ASC";
    NftSaleTypeSortEnum["IdDesc"] = "ID_DESC";
    NftSaleTypeSortEnum["MigrationListingIdAsc"] = "MIGRATION_LISTING_ID_ASC";
    NftSaleTypeSortEnum["MigrationListingIdDesc"] = "MIGRATION_LISTING_ID_DESC";
    NftSaleTypeSortEnum["PriceIdAsc"] = "PRICE_ID_ASC";
    NftSaleTypeSortEnum["PriceIdDesc"] = "PRICE_ID_DESC";
    NftSaleTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    NftSaleTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    NftSaleTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    NftSaleTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    NftSaleTypeSortEnum["TokenIdAsc"] = "TOKEN_ID_ASC";
    NftSaleTypeSortEnum["TokenIdDesc"] = "TOKEN_ID_DESC";
    NftSaleTypeSortEnum["TransferWalletAsc"] = "TRANSFER_WALLET_ASC";
    NftSaleTypeSortEnum["TransferWalletDesc"] = "TRANSFER_WALLET_DESC";
    NftSaleTypeSortEnum["UserIdAsc"] = "USER_ID_ASC";
    NftSaleTypeSortEnum["UserIdDesc"] = "USER_ID_DESC";
})(NftSaleTypeSortEnum = exports.NftSaleTypeSortEnum || (exports.NftSaleTypeSortEnum = {}));
var NotificationHistoryTypeSortEnum;
(function (NotificationHistoryTypeSortEnum) {
    NotificationHistoryTypeSortEnum["ExternalUserIdAsc"] = "EXTERNAL_USER_ID_ASC";
    NotificationHistoryTypeSortEnum["ExternalUserIdDesc"] = "EXTERNAL_USER_ID_DESC";
    NotificationHistoryTypeSortEnum["IdempotencyMarkerAsc"] = "IDEMPOTENCY_MARKER_ASC";
    NotificationHistoryTypeSortEnum["IdempotencyMarkerDesc"] = "IDEMPOTENCY_MARKER_DESC";
    NotificationHistoryTypeSortEnum["IdAsc"] = "ID_ASC";
    NotificationHistoryTypeSortEnum["IdDesc"] = "ID_DESC";
    NotificationHistoryTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    NotificationHistoryTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    NotificationHistoryTypeSortEnum["IsReadAsc"] = "IS_READ_ASC";
    NotificationHistoryTypeSortEnum["IsReadDesc"] = "IS_READ_DESC";
    NotificationHistoryTypeSortEnum["MessageAsc"] = "MESSAGE_ASC";
    NotificationHistoryTypeSortEnum["MessageDesc"] = "MESSAGE_DESC";
    NotificationHistoryTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    NotificationHistoryTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    NotificationHistoryTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    NotificationHistoryTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    NotificationHistoryTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    NotificationHistoryTypeSortEnum["TitleDesc"] = "TITLE_DESC";
    NotificationHistoryTypeSortEnum["UrlAsc"] = "URL_ASC";
    NotificationHistoryTypeSortEnum["UrlDesc"] = "URL_DESC";
})(NotificationHistoryTypeSortEnum = exports.NotificationHistoryTypeSortEnum || (exports.NotificationHistoryTypeSortEnum = {}));
var OrderTypeSortEnum;
(function (OrderTypeSortEnum) {
    OrderTypeSortEnum["CurrentOfferPriceAsc"] = "CURRENT_OFFER_PRICE_ASC";
    OrderTypeSortEnum["CurrentOfferPriceDesc"] = "CURRENT_OFFER_PRICE_DESC";
    OrderTypeSortEnum["CustomerEmailAsc"] = "CUSTOMER_EMAIL_ASC";
    OrderTypeSortEnum["CustomerEmailDesc"] = "CUSTOMER_EMAIL_DESC";
    OrderTypeSortEnum["CustomerTypeAsc"] = "CUSTOMER_TYPE_ASC";
    OrderTypeSortEnum["CustomerTypeDesc"] = "CUSTOMER_TYPE_DESC";
    OrderTypeSortEnum["DealRoomIdAsc"] = "DEAL_ROOM_ID_ASC";
    OrderTypeSortEnum["DealRoomIdDesc"] = "DEAL_ROOM_ID_DESC";
    OrderTypeSortEnum["IdAsc"] = "ID_ASC";
    OrderTypeSortEnum["IdDesc"] = "ID_DESC";
    OrderTypeSortEnum["ProductShopifyIdAsc"] = "PRODUCT_SHOPIFY_ID_ASC";
    OrderTypeSortEnum["ProductShopifyIdDesc"] = "PRODUCT_SHOPIFY_ID_DESC";
    OrderTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    OrderTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    OrderTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    OrderTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    OrderTypeSortEnum["ShopifyIdAsc"] = "SHOPIFY_ID_ASC";
    OrderTypeSortEnum["ShopifyIdDesc"] = "SHOPIFY_ID_DESC";
    OrderTypeSortEnum["SignatureAsc"] = "SIGNATURE_ASC";
    OrderTypeSortEnum["SignatureDesc"] = "SIGNATURE_DESC";
    OrderTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    OrderTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    OrderTypeSortEnum["ZohoRecordIdAsc"] = "ZOHO_RECORD_ID_ASC";
    OrderTypeSortEnum["ZohoRecordIdDesc"] = "ZOHO_RECORD_ID_DESC";
})(OrderTypeSortEnum = exports.OrderTypeSortEnum || (exports.OrderTypeSortEnum = {}));
var ParsedLotTypeSortEnum;
(function (ParsedLotTypeSortEnum) {
    ParsedLotTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    ParsedLotTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    ParsedLotTypeSortEnum["CatalogNotesAsc"] = "CATALOG_NOTES_ASC";
    ParsedLotTypeSortEnum["CatalogNotesDesc"] = "CATALOG_NOTES_DESC";
    ParsedLotTypeSortEnum["DescriptionIdAsc"] = "DESCRIPTION_ID_ASC";
    ParsedLotTypeSortEnum["DescriptionIdDesc"] = "DESCRIPTION_ID_DESC";
    ParsedLotTypeSortEnum["EidAsc"] = "EID_ASC";
    ParsedLotTypeSortEnum["EidDesc"] = "EID_DESC";
    ParsedLotTypeSortEnum["HouseGuaranteedMarkAsc"] = "HOUSE_GUARANTEED_MARK_ASC";
    ParsedLotTypeSortEnum["HouseGuaranteedMarkDesc"] = "HOUSE_GUARANTEED_MARK_DESC";
    ParsedLotTypeSortEnum["IdAsc"] = "ID_ASC";
    ParsedLotTypeSortEnum["IdDesc"] = "ID_DESC";
    ParsedLotTypeSortEnum["IsEstimateUponRequestAsc"] = "IS_ESTIMATE_UPON_REQUEST_ASC";
    ParsedLotTypeSortEnum["IsEstimateUponRequestDesc"] = "IS_ESTIMATE_UPON_REQUEST_DESC";
    ParsedLotTypeSortEnum["IsMultipleObjectsAsc"] = "IS_MULTIPLE_OBJECTS_ASC";
    ParsedLotTypeSortEnum["IsMultipleObjectsDesc"] = "IS_MULTIPLE_OBJECTS_DESC";
    ParsedLotTypeSortEnum["NumberAsc"] = "NUMBER_ASC";
    ParsedLotTypeSortEnum["NumberDesc"] = "NUMBER_DESC";
    ParsedLotTypeSortEnum["PriceIdAsc"] = "PRICE_ID_ASC";
    ParsedLotTypeSortEnum["PriceIdDesc"] = "PRICE_ID_DESC";
    ParsedLotTypeSortEnum["PublishedIdAsc"] = "PUBLISHED_ID_ASC";
    ParsedLotTypeSortEnum["PublishedIdDesc"] = "PUBLISHED_ID_DESC";
    ParsedLotTypeSortEnum["ReserveMarkAsc"] = "RESERVE_MARK_ASC";
    ParsedLotTypeSortEnum["ReserveMarkDesc"] = "RESERVE_MARK_DESC";
    ParsedLotTypeSortEnum["SaleIdAsc"] = "SALE_ID_ASC";
    ParsedLotTypeSortEnum["SaleIdDesc"] = "SALE_ID_DESC";
    ParsedLotTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    ParsedLotTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    ParsedLotTypeSortEnum["ThirdPartyMarkAsc"] = "THIRD_PARTY_MARK_ASC";
    ParsedLotTypeSortEnum["ThirdPartyMarkDesc"] = "THIRD_PARTY_MARK_DESC";
    ParsedLotTypeSortEnum["UrlAsc"] = "URL_ASC";
    ParsedLotTypeSortEnum["UrlDesc"] = "URL_DESC";
})(ParsedLotTypeSortEnum = exports.ParsedLotTypeSortEnum || (exports.ParsedLotTypeSortEnum = {}));
var ParsedSaleTypeSortEnum;
(function (ParsedSaleTypeSortEnum) {
    ParsedSaleTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    ParsedSaleTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    ParsedSaleTypeSortEnum["BiddingEndsAsc"] = "BIDDING_ENDS_ASC";
    ParsedSaleTypeSortEnum["BiddingEndsDesc"] = "BIDDING_ENDS_DESC";
    ParsedSaleTypeSortEnum["BiddingStartsAsc"] = "BIDDING_STARTS_ASC";
    ParsedSaleTypeSortEnum["BiddingStartsDesc"] = "BIDDING_STARTS_DESC";
    ParsedSaleTypeSortEnum["DisableParsingAsc"] = "DISABLE_PARSING_ASC";
    ParsedSaleTypeSortEnum["DisableParsingDesc"] = "DISABLE_PARSING_DESC";
    ParsedSaleTypeSortEnum["EidAsc"] = "EID_ASC";
    ParsedSaleTypeSortEnum["EidDesc"] = "EID_DESC";
    ParsedSaleTypeSortEnum["EndDatetimeAsc"] = "END_DATETIME_ASC";
    ParsedSaleTypeSortEnum["EndDatetimeDesc"] = "END_DATETIME_DESC";
    ParsedSaleTypeSortEnum["IdAsc"] = "ID_ASC";
    ParsedSaleTypeSortEnum["IdDesc"] = "ID_DESC";
    ParsedSaleTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    ParsedSaleTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    ParsedSaleTypeSortEnum["IsLaeLockedAsc"] = "IS_LAE_LOCKED_ASC";
    ParsedSaleTypeSortEnum["IsLaeLockedDesc"] = "IS_LAE_LOCKED_DESC";
    ParsedSaleTypeSortEnum["LiveAsc"] = "LIVE_ASC";
    ParsedSaleTypeSortEnum["LiveDesc"] = "LIVE_DESC";
    ParsedSaleTypeSortEnum["LocationAsc"] = "LOCATION_ASC";
    ParsedSaleTypeSortEnum["LocationDesc"] = "LOCATION_DESC";
    ParsedSaleTypeSortEnum["LotsCountAsc"] = "LOTS_COUNT_ASC";
    ParsedSaleTypeSortEnum["LotsCountDesc"] = "LOTS_COUNT_DESC";
    ParsedSaleTypeSortEnum["NameAsc"] = "NAME_ASC";
    ParsedSaleTypeSortEnum["NameDesc"] = "NAME_DESC";
    ParsedSaleTypeSortEnum["NumberAsc"] = "NUMBER_ASC";
    ParsedSaleTypeSortEnum["NumberDesc"] = "NUMBER_DESC";
    ParsedSaleTypeSortEnum["OnlineAsc"] = "ONLINE_ASC";
    ParsedSaleTypeSortEnum["OnlineDesc"] = "ONLINE_DESC";
    ParsedSaleTypeSortEnum["PriceIdAsc"] = "PRICE_ID_ASC";
    ParsedSaleTypeSortEnum["PriceIdDesc"] = "PRICE_ID_DESC";
    ParsedSaleTypeSortEnum["PublishedIdAsc"] = "PUBLISHED_ID_ASC";
    ParsedSaleTypeSortEnum["PublishedIdDesc"] = "PUBLISHED_ID_DESC";
    ParsedSaleTypeSortEnum["PublishStatusAsc"] = "PUBLISH_STATUS_ASC";
    ParsedSaleTypeSortEnum["PublishStatusDesc"] = "PUBLISH_STATUS_DESC";
    ParsedSaleTypeSortEnum["RateByLotAsc"] = "RATE_BY_LOT_ASC";
    ParsedSaleTypeSortEnum["RateByLotDesc"] = "RATE_BY_LOT_DESC";
    ParsedSaleTypeSortEnum["RateByValueAsc"] = "RATE_BY_VALUE_ASC";
    ParsedSaleTypeSortEnum["RateByValueDesc"] = "RATE_BY_VALUE_DESC";
    ParsedSaleTypeSortEnum["StartDatetimeAsc"] = "START_DATETIME_ASC";
    ParsedSaleTypeSortEnum["StartDatetimeDesc"] = "START_DATETIME_DESC";
    ParsedSaleTypeSortEnum["UrlAsc"] = "URL_ASC";
    ParsedSaleTypeSortEnum["UrlDesc"] = "URL_DESC";
})(ParsedSaleTypeSortEnum = exports.ParsedSaleTypeSortEnum || (exports.ParsedSaleTypeSortEnum = {}));
var PriceKind;
(function (PriceKind) {
    PriceKind["Hammer"] = "hammer";
    PriceKind["Premium"] = "premium";
})(PriceKind = exports.PriceKind || (exports.PriceKind = {}));
var PriceTypeSortEnum;
(function (PriceTypeSortEnum) {
    PriceTypeSortEnum["CurrencyAsc"] = "CURRENCY_ASC";
    PriceTypeSortEnum["CurrencyDesc"] = "CURRENCY_DESC";
    PriceTypeSortEnum["DateAsc"] = "DATE_ASC";
    PriceTypeSortEnum["DateDesc"] = "DATE_DESC";
    PriceTypeSortEnum["HammerAsc"] = "HAMMER_ASC";
    PriceTypeSortEnum["HammerDesc"] = "HAMMER_DESC";
    PriceTypeSortEnum["HammerEstimateMaxAsc"] = "HAMMER_ESTIMATE_MAX_ASC";
    PriceTypeSortEnum["HammerEstimateMaxDesc"] = "HAMMER_ESTIMATE_MAX_DESC";
    PriceTypeSortEnum["HammerEstimateMaxUsdAsc"] = "HAMMER_ESTIMATE_MAX_USD_ASC";
    PriceTypeSortEnum["HammerEstimateMaxUsdDesc"] = "HAMMER_ESTIMATE_MAX_USD_DESC";
    PriceTypeSortEnum["HammerEstimateMinAsc"] = "HAMMER_ESTIMATE_MIN_ASC";
    PriceTypeSortEnum["HammerEstimateMinDesc"] = "HAMMER_ESTIMATE_MIN_DESC";
    PriceTypeSortEnum["HammerEstimateMinUsdAsc"] = "HAMMER_ESTIMATE_MIN_USD_ASC";
    PriceTypeSortEnum["HammerEstimateMinUsdDesc"] = "HAMMER_ESTIMATE_MIN_USD_DESC";
    PriceTypeSortEnum["HammerUsdAsc"] = "HAMMER_USD_ASC";
    PriceTypeSortEnum["HammerUsdDesc"] = "HAMMER_USD_DESC";
    PriceTypeSortEnum["IdAsc"] = "ID_ASC";
    PriceTypeSortEnum["IdDesc"] = "ID_DESC";
    PriceTypeSortEnum["KindAsc"] = "KIND_ASC";
    PriceTypeSortEnum["KindDesc"] = "KIND_DESC";
    PriceTypeSortEnum["PremiumAsc"] = "PREMIUM_ASC";
    PriceTypeSortEnum["PremiumDesc"] = "PREMIUM_DESC";
    PriceTypeSortEnum["PremiumEstimateMaxAsc"] = "PREMIUM_ESTIMATE_MAX_ASC";
    PriceTypeSortEnum["PremiumEstimateMaxDesc"] = "PREMIUM_ESTIMATE_MAX_DESC";
    PriceTypeSortEnum["PremiumEstimateMaxUsdAsc"] = "PREMIUM_ESTIMATE_MAX_USD_ASC";
    PriceTypeSortEnum["PremiumEstimateMaxUsdDesc"] = "PREMIUM_ESTIMATE_MAX_USD_DESC";
    PriceTypeSortEnum["PremiumEstimateMinAsc"] = "PREMIUM_ESTIMATE_MIN_ASC";
    PriceTypeSortEnum["PremiumEstimateMinDesc"] = "PREMIUM_ESTIMATE_MIN_DESC";
    PriceTypeSortEnum["PremiumEstimateMinUsdAsc"] = "PREMIUM_ESTIMATE_MIN_USD_ASC";
    PriceTypeSortEnum["PremiumEstimateMinUsdDesc"] = "PREMIUM_ESTIMATE_MIN_USD_DESC";
    PriceTypeSortEnum["PremiumUsdAsc"] = "PREMIUM_USD_ASC";
    PriceTypeSortEnum["PremiumUsdDesc"] = "PREMIUM_USD_DESC";
})(PriceTypeSortEnum = exports.PriceTypeSortEnum || (exports.PriceTypeSortEnum = {}));
var PrivateStatusEnum;
(function (PrivateStatusEnum) {
    PrivateStatusEnum["Private"] = "private";
    PrivateStatusEnum["Public"] = "public";
})(PrivateStatusEnum = exports.PrivateStatusEnum || (exports.PrivateStatusEnum = {}));
var ProductTypeSortEnum;
(function (ProductTypeSortEnum) {
    ProductTypeSortEnum["AcquisitionInformationAsc"] = "ACQUISITION_INFORMATION_ASC";
    ProductTypeSortEnum["AcquisitionInformationDesc"] = "ACQUISITION_INFORMATION_DESC";
    ProductTypeSortEnum["ArtistAsc"] = "ARTIST_ASC";
    ProductTypeSortEnum["ArtistDesc"] = "ARTIST_DESC";
    ProductTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    ProductTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    ProductTypeSortEnum["ArtistNameAsc"] = "ARTIST_NAME_ASC";
    ProductTypeSortEnum["ArtistNameDesc"] = "ARTIST_NAME_DESC";
    ProductTypeSortEnum["ArtworkLocationAsc"] = "ARTWORK_LOCATION_ASC";
    ProductTypeSortEnum["ArtworkLocationDesc"] = "ARTWORK_LOCATION_DESC";
    ProductTypeSortEnum["CategoryAsc"] = "CATEGORY_ASC";
    ProductTypeSortEnum["CategoryDesc"] = "CATEGORY_DESC";
    ProductTypeSortEnum["CategoryIdAsc"] = "CATEGORY_ID_ASC";
    ProductTypeSortEnum["CategoryIdDesc"] = "CATEGORY_ID_DESC";
    ProductTypeSortEnum["CategoryLabelAsc"] = "CATEGORY_LABEL_ASC";
    ProductTypeSortEnum["CategoryLabelDesc"] = "CATEGORY_LABEL_DESC";
    ProductTypeSortEnum["ConditionAsc"] = "CONDITION_ASC";
    ProductTypeSortEnum["ConditionDesc"] = "CONDITION_DESC";
    ProductTypeSortEnum["CreatedAtAsc"] = "CREATED_AT_ASC";
    ProductTypeSortEnum["CreatedAtDesc"] = "CREATED_AT_DESC";
    ProductTypeSortEnum["CreationYearAsc"] = "CREATION_YEAR_ASC";
    ProductTypeSortEnum["CreationYearDesc"] = "CREATION_YEAR_DESC";
    ProductTypeSortEnum["DamageAsc"] = "DAMAGE_ASC";
    ProductTypeSortEnum["DamageDesc"] = "DAMAGE_DESC";
    ProductTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    ProductTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    ProductTypeSortEnum["DescriptionIdAsc"] = "DESCRIPTION_ID_ASC";
    ProductTypeSortEnum["DescriptionIdDesc"] = "DESCRIPTION_ID_DESC";
    ProductTypeSortEnum["DescriptionTypeAsc"] = "DESCRIPTION_TYPE_ASC";
    ProductTypeSortEnum["DescriptionTypeDesc"] = "DESCRIPTION_TYPE_DESC";
    ProductTypeSortEnum["EditionDetailsAsc"] = "EDITION_DETAILS_ASC";
    ProductTypeSortEnum["EditionDetailsDesc"] = "EDITION_DETAILS_DESC";
    ProductTypeSortEnum["ExhibitionHistoryAsc"] = "EXHIBITION_HISTORY_ASC";
    ProductTypeSortEnum["ExhibitionHistoryDesc"] = "EXHIBITION_HISTORY_DESC";
    ProductTypeSortEnum["FramedMeasurementsDepthAsc"] = "FRAMED_MEASUREMENTS_DEPTH_ASC";
    ProductTypeSortEnum["FramedMeasurementsDepthCmAsc"] = "FRAMED_MEASUREMENTS_DEPTH_CM_ASC";
    ProductTypeSortEnum["FramedMeasurementsDepthCmDesc"] = "FRAMED_MEASUREMENTS_DEPTH_CM_DESC";
    ProductTypeSortEnum["FramedMeasurementsDepthDesc"] = "FRAMED_MEASUREMENTS_DEPTH_DESC";
    ProductTypeSortEnum["FramedMeasurementsDepthInchAsc"] = "FRAMED_MEASUREMENTS_DEPTH_INCH_ASC";
    ProductTypeSortEnum["FramedMeasurementsDepthInchDesc"] = "FRAMED_MEASUREMENTS_DEPTH_INCH_DESC";
    ProductTypeSortEnum["FramedMeasurementsHeightAsc"] = "FRAMED_MEASUREMENTS_HEIGHT_ASC";
    ProductTypeSortEnum["FramedMeasurementsHeightCmAsc"] = "FRAMED_MEASUREMENTS_HEIGHT_CM_ASC";
    ProductTypeSortEnum["FramedMeasurementsHeightCmDesc"] = "FRAMED_MEASUREMENTS_HEIGHT_CM_DESC";
    ProductTypeSortEnum["FramedMeasurementsHeightDesc"] = "FRAMED_MEASUREMENTS_HEIGHT_DESC";
    ProductTypeSortEnum["FramedMeasurementsHeightInchAsc"] = "FRAMED_MEASUREMENTS_HEIGHT_INCH_ASC";
    ProductTypeSortEnum["FramedMeasurementsHeightInchDesc"] = "FRAMED_MEASUREMENTS_HEIGHT_INCH_DESC";
    ProductTypeSortEnum["FramedMeasurementsWidthAsc"] = "FRAMED_MEASUREMENTS_WIDTH_ASC";
    ProductTypeSortEnum["FramedMeasurementsWidthCmAsc"] = "FRAMED_MEASUREMENTS_WIDTH_CM_ASC";
    ProductTypeSortEnum["FramedMeasurementsWidthCmDesc"] = "FRAMED_MEASUREMENTS_WIDTH_CM_DESC";
    ProductTypeSortEnum["FramedMeasurementsWidthDesc"] = "FRAMED_MEASUREMENTS_WIDTH_DESC";
    ProductTypeSortEnum["FramedMeasurementsWidthInchAsc"] = "FRAMED_MEASUREMENTS_WIDTH_INCH_ASC";
    ProductTypeSortEnum["FramedMeasurementsWidthInchDesc"] = "FRAMED_MEASUREMENTS_WIDTH_INCH_DESC";
    ProductTypeSortEnum["IdAsc"] = "ID_ASC";
    ProductTypeSortEnum["IdDesc"] = "ID_DESC";
    ProductTypeSortEnum["InscriptionAsc"] = "INSCRIPTION_ASC";
    ProductTypeSortEnum["InscriptionDesc"] = "INSCRIPTION_DESC";
    ProductTypeSortEnum["IsHiddenAsc"] = "IS_HIDDEN_ASC";
    ProductTypeSortEnum["IsHiddenDesc"] = "IS_HIDDEN_DESC";
    ProductTypeSortEnum["IsSoldAsc"] = "IS_SOLD_ASC";
    ProductTypeSortEnum["IsSoldDesc"] = "IS_SOLD_DESC";
    ProductTypeSortEnum["LabelsAsc"] = "LABELS_ASC";
    ProductTypeSortEnum["LabelsDesc"] = "LABELS_DESC";
    ProductTypeSortEnum["ListingDateAsc"] = "LISTING_DATE_ASC";
    ProductTypeSortEnum["ListingDateDesc"] = "LISTING_DATE_DESC";
    ProductTypeSortEnum["MarkingsAsc"] = "MARKINGS_ASC";
    ProductTypeSortEnum["MarkingsDesc"] = "MARKINGS_DESC";
    ProductTypeSortEnum["MaterialsAsc"] = "MATERIALS_ASC";
    ProductTypeSortEnum["MaterialsDesc"] = "MATERIALS_DESC";
    ProductTypeSortEnum["MeasurementsDepthAsc"] = "MEASUREMENTS_DEPTH_ASC";
    ProductTypeSortEnum["MeasurementsDepthCmAsc"] = "MEASUREMENTS_DEPTH_CM_ASC";
    ProductTypeSortEnum["MeasurementsDepthCmDesc"] = "MEASUREMENTS_DEPTH_CM_DESC";
    ProductTypeSortEnum["MeasurementsDepthDesc"] = "MEASUREMENTS_DEPTH_DESC";
    ProductTypeSortEnum["MeasurementsDepthInchAsc"] = "MEASUREMENTS_DEPTH_INCH_ASC";
    ProductTypeSortEnum["MeasurementsDepthInchDesc"] = "MEASUREMENTS_DEPTH_INCH_DESC";
    ProductTypeSortEnum["MeasurementsHeightAsc"] = "MEASUREMENTS_HEIGHT_ASC";
    ProductTypeSortEnum["MeasurementsHeightCmAsc"] = "MEASUREMENTS_HEIGHT_CM_ASC";
    ProductTypeSortEnum["MeasurementsHeightCmDesc"] = "MEASUREMENTS_HEIGHT_CM_DESC";
    ProductTypeSortEnum["MeasurementsHeightDesc"] = "MEASUREMENTS_HEIGHT_DESC";
    ProductTypeSortEnum["MeasurementsHeightInchAsc"] = "MEASUREMENTS_HEIGHT_INCH_ASC";
    ProductTypeSortEnum["MeasurementsHeightInchDesc"] = "MEASUREMENTS_HEIGHT_INCH_DESC";
    ProductTypeSortEnum["MeasurementsUnitAsc"] = "MEASUREMENTS_UNIT_ASC";
    ProductTypeSortEnum["MeasurementsUnitDesc"] = "MEASUREMENTS_UNIT_DESC";
    ProductTypeSortEnum["MeasurementsWidthAsc"] = "MEASUREMENTS_WIDTH_ASC";
    ProductTypeSortEnum["MeasurementsWidthCmAsc"] = "MEASUREMENTS_WIDTH_CM_ASC";
    ProductTypeSortEnum["MeasurementsWidthCmDesc"] = "MEASUREMENTS_WIDTH_CM_DESC";
    ProductTypeSortEnum["MeasurementsWidthDesc"] = "MEASUREMENTS_WIDTH_DESC";
    ProductTypeSortEnum["MeasurementsWidthInchAsc"] = "MEASUREMENTS_WIDTH_INCH_ASC";
    ProductTypeSortEnum["MeasurementsWidthInchDesc"] = "MEASUREMENTS_WIDTH_INCH_DESC";
    ProductTypeSortEnum["MediumAsc"] = "MEDIUM_ASC";
    ProductTypeSortEnum["MediumDesc"] = "MEDIUM_DESC";
    ProductTypeSortEnum["OldShopifyIdAsc"] = "OLD_SHOPIFY_ID_ASC";
    ProductTypeSortEnum["OldShopifyIdDesc"] = "OLD_SHOPIFY_ID_DESC";
    ProductTypeSortEnum["PriceCurrencyAsc"] = "PRICE_CURRENCY_ASC";
    ProductTypeSortEnum["PriceCurrencyDesc"] = "PRICE_CURRENCY_DESC";
    ProductTypeSortEnum["PriceMaxAsc"] = "PRICE_MAX_ASC";
    ProductTypeSortEnum["PriceMaxDesc"] = "PRICE_MAX_DESC";
    ProductTypeSortEnum["PriceMaxPreferredCurrencyAsc"] = "PRICE_MAX_PREFERRED_CURRENCY_ASC";
    ProductTypeSortEnum["PriceMaxPreferredCurrencyDesc"] = "PRICE_MAX_PREFERRED_CURRENCY_DESC";
    ProductTypeSortEnum["PriceMinAsc"] = "PRICE_MIN_ASC";
    ProductTypeSortEnum["PriceMinDesc"] = "PRICE_MIN_DESC";
    ProductTypeSortEnum["PriceMinPreferredCurrencyAsc"] = "PRICE_MIN_PREFERRED_CURRENCY_ASC";
    ProductTypeSortEnum["PriceMinPreferredCurrencyDesc"] = "PRICE_MIN_PREFERRED_CURRENCY_DESC";
    ProductTypeSortEnum["PrivateCreationYearAsc"] = "PRIVATE_CREATION_YEAR_ASC";
    ProductTypeSortEnum["PrivateCreationYearDesc"] = "PRIVATE_CREATION_YEAR_DESC";
    ProductTypeSortEnum["PrivateStatusAsc"] = "PRIVATE_STATUS_ASC";
    ProductTypeSortEnum["PrivateStatusDesc"] = "PRIVATE_STATUS_DESC";
    ProductTypeSortEnum["PrivateTitleAsc"] = "PRIVATE_TITLE_ASC";
    ProductTypeSortEnum["PrivateTitleDesc"] = "PRIVATE_TITLE_DESC";
    ProductTypeSortEnum["ProductCategoryAsc"] = "PRODUCT_CATEGORY_ASC";
    ProductTypeSortEnum["ProductCategoryDesc"] = "PRODUCT_CATEGORY_DESC";
    ProductTypeSortEnum["ProvenanceAsc"] = "PROVENANCE_ASC";
    ProductTypeSortEnum["ProvenanceDesc"] = "PROVENANCE_DESC";
    ProductTypeSortEnum["PublishedAtAsc"] = "PUBLISHED_AT_ASC";
    ProductTypeSortEnum["PublishedAtDesc"] = "PUBLISHED_AT_DESC";
    ProductTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    ProductTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    ProductTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    ProductTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    ProductTypeSortEnum["SellerIdAsc"] = "SELLER_ID_ASC";
    ProductTypeSortEnum["SellerIdDesc"] = "SELLER_ID_DESC";
    ProductTypeSortEnum["SellerShopifyIdAsc"] = "SELLER_SHOPIFY_ID_ASC";
    ProductTypeSortEnum["SellerShopifyIdDesc"] = "SELLER_SHOPIFY_ID_DESC";
    ProductTypeSortEnum["ShopifyIdAsc"] = "SHOPIFY_ID_ASC";
    ProductTypeSortEnum["ShopifyIdDesc"] = "SHOPIFY_ID_DESC";
    ProductTypeSortEnum["SignatureAsc"] = "SIGNATURE_ASC";
    ProductTypeSortEnum["SignatureDesc"] = "SIGNATURE_DESC";
    ProductTypeSortEnum["SlugAsc"] = "SLUG_ASC";
    ProductTypeSortEnum["SlugDesc"] = "SLUG_DESC";
    ProductTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    ProductTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    ProductTypeSortEnum["TagsAsc"] = "TAGS_ASC";
    ProductTypeSortEnum["TagsDesc"] = "TAGS_DESC";
    ProductTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    ProductTypeSortEnum["TitleDesc"] = "TITLE_DESC";
    ProductTypeSortEnum["VendorAsc"] = "VENDOR_ASC";
    ProductTypeSortEnum["VendorDesc"] = "VENDOR_DESC";
    ProductTypeSortEnum["WithoutDamageAsc"] = "WITHOUT_DAMAGE_ASC";
    ProductTypeSortEnum["WithoutDamageDesc"] = "WITHOUT_DAMAGE_DESC";
})(ProductTypeSortEnum = exports.ProductTypeSortEnum || (exports.ProductTypeSortEnum = {}));
var ProductUnits;
(function (ProductUnits) {
    ProductUnits["Centimeters"] = "centimeters";
    ProductUnits["Inches"] = "inches";
    ProductUnits["Millimeters"] = "millimeters";
})(ProductUnits = exports.ProductUnits || (exports.ProductUnits = {}));
var ProductWishlistUnionSortArgument;
(function (ProductWishlistUnionSortArgument) {
    ProductWishlistUnionSortArgument["ArtistNameAsc"] = "ARTIST_NAME_ASC";
    ProductWishlistUnionSortArgument["ArtistNameDesc"] = "ARTIST_NAME_DESC";
    ProductWishlistUnionSortArgument["IdAsc"] = "ID_ASC";
    ProductWishlistUnionSortArgument["PriceAsc"] = "PRICE_ASC";
    ProductWishlistUnionSortArgument["PriceDesc"] = "PRICE_DESC";
    ProductWishlistUnionSortArgument["PublishedAtAsc"] = "PUBLISHED_AT_ASC";
    ProductWishlistUnionSortArgument["PublishedAtDesc"] = "PUBLISHED_AT_DESC";
    ProductWishlistUnionSortArgument["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    ProductWishlistUnionSortArgument["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
})(ProductWishlistUnionSortArgument = exports.ProductWishlistUnionSortArgument || (exports.ProductWishlistUnionSortArgument = {}));
var RelatedArtistTypeSortEnum;
(function (RelatedArtistTypeSortEnum) {
    RelatedArtistTypeSortEnum["BirthAsc"] = "BIRTH_ASC";
    RelatedArtistTypeSortEnum["BirthDesc"] = "BIRTH_DESC";
    RelatedArtistTypeSortEnum["IdAsc"] = "ID_ASC";
    RelatedArtistTypeSortEnum["IdDesc"] = "ID_DESC";
    RelatedArtistTypeSortEnum["NameAsc"] = "NAME_ASC";
    RelatedArtistTypeSortEnum["NameDesc"] = "NAME_DESC";
    RelatedArtistTypeSortEnum["NationalityAsc"] = "NATIONALITY_ASC";
    RelatedArtistTypeSortEnum["NationalityDesc"] = "NATIONALITY_DESC";
    RelatedArtistTypeSortEnum["PhotoAsc"] = "PHOTO_ASC";
    RelatedArtistTypeSortEnum["PhotoDesc"] = "PHOTO_DESC";
    RelatedArtistTypeSortEnum["PhotoIdAsc"] = "PHOTO_ID_ASC";
    RelatedArtistTypeSortEnum["PhotoIdDesc"] = "PHOTO_ID_DESC";
    RelatedArtistTypeSortEnum["UidAsc"] = "UID_ASC";
    RelatedArtistTypeSortEnum["UidDesc"] = "UID_DESC";
})(RelatedArtistTypeSortEnum = exports.RelatedArtistTypeSortEnum || (exports.RelatedArtistTypeSortEnum = {}));
var SaleTransactionTypeSortEnum;
(function (SaleTransactionTypeSortEnum) {
    SaleTransactionTypeSortEnum["BuyerUserAsc"] = "BUYER_USER_ASC";
    SaleTransactionTypeSortEnum["BuyerUserDesc"] = "BUYER_USER_DESC";
    SaleTransactionTypeSortEnum["BuyerUserIdAsc"] = "BUYER_USER_ID_ASC";
    SaleTransactionTypeSortEnum["BuyerUserIdDesc"] = "BUYER_USER_ID_DESC";
    SaleTransactionTypeSortEnum["IdAsc"] = "ID_ASC";
    SaleTransactionTypeSortEnum["IdDesc"] = "ID_DESC";
    SaleTransactionTypeSortEnum["PriceIdAsc"] = "PRICE_ID_ASC";
    SaleTransactionTypeSortEnum["PriceIdDesc"] = "PRICE_ID_DESC";
    SaleTransactionTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    SaleTransactionTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    SaleTransactionTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    SaleTransactionTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    SaleTransactionTypeSortEnum["SaleIdAsc"] = "SALE_ID_ASC";
    SaleTransactionTypeSortEnum["SaleIdDesc"] = "SALE_ID_DESC";
    SaleTransactionTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    SaleTransactionTypeSortEnum["StatusDesc"] = "STATUS_DESC";
})(SaleTransactionTypeSortEnum = exports.SaleTransactionTypeSortEnum || (exports.SaleTransactionTypeSortEnum = {}));
var SaleTypeSortEnum;
(function (SaleTypeSortEnum) {
    SaleTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    SaleTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    SaleTypeSortEnum["AuctionHouseNameAsc"] = "AUCTION_HOUSE_NAME_ASC";
    SaleTypeSortEnum["AuctionHouseNameDesc"] = "AUCTION_HOUSE_NAME_DESC";
    SaleTypeSortEnum["AuctionUrlAsc"] = "AUCTION_URL_ASC";
    SaleTypeSortEnum["AuctionUrlDesc"] = "AUCTION_URL_DESC";
    SaleTypeSortEnum["CurrencyAsc"] = "CURRENCY_ASC";
    SaleTypeSortEnum["CurrencyDesc"] = "CURRENCY_DESC";
    SaleTypeSortEnum["EndDatetimeAsc"] = "END_DATETIME_ASC";
    SaleTypeSortEnum["EndDatetimeDesc"] = "END_DATETIME_DESC";
    SaleTypeSortEnum["HammerHighEstimateAsc"] = "HAMMER_HIGH_ESTIMATE_ASC";
    SaleTypeSortEnum["HammerHighEstimateDesc"] = "HAMMER_HIGH_ESTIMATE_DESC";
    SaleTypeSortEnum["HammerHighEstimateUsdZeroiedAsc"] = "HAMMER_HIGH_ESTIMATE_USD_ZEROIED_ASC";
    SaleTypeSortEnum["HammerHighEstimateUsdZeroiedDesc"] = "HAMMER_HIGH_ESTIMATE_USD_ZEROIED_DESC";
    SaleTypeSortEnum["HammerLowEstimateAsc"] = "HAMMER_LOW_ESTIMATE_ASC";
    SaleTypeSortEnum["HammerLowEstimateDesc"] = "HAMMER_LOW_ESTIMATE_DESC";
    SaleTypeSortEnum["HammerLowEstimateUsdZeroiedAsc"] = "HAMMER_LOW_ESTIMATE_USD_ZEROIED_ASC";
    SaleTypeSortEnum["HammerLowEstimateUsdZeroiedDesc"] = "HAMMER_LOW_ESTIMATE_USD_ZEROIED_DESC";
    SaleTypeSortEnum["HammerSoldTotalPreferredCurrencyAsc"] = "HAMMER_SOLD_TOTAL_PREFERRED_CURRENCY_ASC";
    SaleTypeSortEnum["HammerSoldTotalPreferredCurrencyDesc"] = "HAMMER_SOLD_TOTAL_PREFERRED_CURRENCY_DESC";
    SaleTypeSortEnum["HammerTotalAsc"] = "HAMMER_TOTAL_ASC";
    SaleTypeSortEnum["HammerTotalDesc"] = "HAMMER_TOTAL_DESC";
    SaleTypeSortEnum["HammerTotalUsdZeroiedAsc"] = "HAMMER_TOTAL_USD_ZEROIED_ASC";
    SaleTypeSortEnum["HammerTotalUsdZeroiedDesc"] = "HAMMER_TOTAL_USD_ZEROIED_DESC";
    SaleTypeSortEnum["IdAsc"] = "ID_ASC";
    SaleTypeSortEnum["IdDesc"] = "ID_DESC";
    SaleTypeSortEnum["ImageIdAsc"] = "IMAGE_ID_ASC";
    SaleTypeSortEnum["ImageIdDesc"] = "IMAGE_ID_DESC";
    SaleTypeSortEnum["IsHiddenAsc"] = "IS_HIDDEN_ASC";
    SaleTypeSortEnum["IsHiddenDesc"] = "IS_HIDDEN_DESC";
    SaleTypeSortEnum["IsOnlineAsc"] = "IS_ONLINE_ASC";
    SaleTypeSortEnum["IsOnlineDesc"] = "IS_ONLINE_DESC";
    SaleTypeSortEnum["LocationAsc"] = "LOCATION_ASC";
    SaleTypeSortEnum["LocationDesc"] = "LOCATION_DESC";
    SaleTypeSortEnum["LotsCountAsc"] = "LOTS_COUNT_ASC";
    SaleTypeSortEnum["LotsCountDesc"] = "LOTS_COUNT_DESC";
    SaleTypeSortEnum["LotsCountNotSoldAsc"] = "LOTS_COUNT_NOT_SOLD_ASC";
    SaleTypeSortEnum["LotsCountNotSoldDesc"] = "LOTS_COUNT_NOT_SOLD_DESC";
    SaleTypeSortEnum["LotsCountSoldAboveEstimationsAsc"] = "LOTS_COUNT_SOLD_ABOVE_ESTIMATIONS_ASC";
    SaleTypeSortEnum["LotsCountSoldAboveEstimationsDesc"] = "LOTS_COUNT_SOLD_ABOVE_ESTIMATIONS_DESC";
    SaleTypeSortEnum["LotsCountSoldBelowEstimationsAsc"] = "LOTS_COUNT_SOLD_BELOW_ESTIMATIONS_ASC";
    SaleTypeSortEnum["LotsCountSoldBelowEstimationsDesc"] = "LOTS_COUNT_SOLD_BELOW_ESTIMATIONS_DESC";
    SaleTypeSortEnum["LotsCountSoldWithinEstimationsAsc"] = "LOTS_COUNT_SOLD_WITHIN_ESTIMATIONS_ASC";
    SaleTypeSortEnum["LotsCountSoldWithinEstimationsDesc"] = "LOTS_COUNT_SOLD_WITHIN_ESTIMATIONS_DESC";
    SaleTypeSortEnum["NameAsc"] = "NAME_ASC";
    SaleTypeSortEnum["NameDesc"] = "NAME_DESC";
    SaleTypeSortEnum["NumberAsc"] = "NUMBER_ASC";
    SaleTypeSortEnum["NumberDesc"] = "NUMBER_DESC";
    SaleTypeSortEnum["PremiumHighEstimateAsc"] = "PREMIUM_HIGH_ESTIMATE_ASC";
    SaleTypeSortEnum["PremiumHighEstimateDesc"] = "PREMIUM_HIGH_ESTIMATE_DESC";
    SaleTypeSortEnum["PremiumLowEstimateAsc"] = "PREMIUM_LOW_ESTIMATE_ASC";
    SaleTypeSortEnum["PremiumLowEstimateDesc"] = "PREMIUM_LOW_ESTIMATE_DESC";
    SaleTypeSortEnum["PremiumSoldTotalAsc"] = "PREMIUM_SOLD_TOTAL_ASC";
    SaleTypeSortEnum["PremiumSoldTotalDesc"] = "PREMIUM_SOLD_TOTAL_DESC";
    SaleTypeSortEnum["PremiumSoldTotalPreferredCurrencyAsc"] = "PREMIUM_SOLD_TOTAL_PREFERRED_CURRENCY_ASC";
    SaleTypeSortEnum["PremiumSoldTotalPreferredCurrencyDesc"] = "PREMIUM_SOLD_TOTAL_PREFERRED_CURRENCY_DESC";
    SaleTypeSortEnum["PremiumSoldTotalUsdZeroiedAsc"] = "PREMIUM_SOLD_TOTAL_USD_ZEROIED_ASC";
    SaleTypeSortEnum["PremiumSoldTotalUsdZeroiedDesc"] = "PREMIUM_SOLD_TOTAL_USD_ZEROIED_DESC";
    SaleTypeSortEnum["StartDatetimeAsc"] = "START_DATETIME_ASC";
    SaleTypeSortEnum["StartDatetimeDesc"] = "START_DATETIME_DESC";
    SaleTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    SaleTypeSortEnum["StatusDesc"] = "STATUS_DESC";
})(SaleTypeSortEnum = exports.SaleTypeSortEnum || (exports.SaleTypeSortEnum = {}));
var SizeFilter;
(function (SizeFilter) {
    SizeFilter["Big"] = "BIG";
    SizeFilter["Medium"] = "MEDIUM";
    SizeFilter["Other"] = "OTHER";
    SizeFilter["Small"] = "SMALL";
})(SizeFilter = exports.SizeFilter || (exports.SizeFilter = {}));
var SizeFilterValue;
(function (SizeFilterValue) {
    SizeFilterValue["Big"] = "big";
    SizeFilterValue["Medium"] = "medium";
    SizeFilterValue["Other"] = "other";
    SizeFilterValue["Small"] = "small";
})(SizeFilterValue = exports.SizeFilterValue || (exports.SizeFilterValue = {}));
var SortByTotalSales;
(function (SortByTotalSales) {
    SortByTotalSales["Asc"] = "ASC";
    SortByTotalSales["Desc"] = "DESC";
})(SortByTotalSales = exports.SortByTotalSales || (exports.SortByTotalSales = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Active"] = "ACTIVE";
    StatusEnum["ActivePrivate"] = "ACTIVE_PRIVATE";
    StatusEnum["Archived"] = "ARCHIVED";
    StatusEnum["Declined"] = "DECLINED";
    StatusEnum["Draft"] = "DRAFT";
    StatusEnum["Internal"] = "INTERNAL";
    StatusEnum["New"] = "NEW";
    StatusEnum["Sold"] = "SOLD";
    StatusEnum["Unconfirmed"] = "UNCONFIRMED";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var StripeInvoiceTypeSortEnum;
(function (StripeInvoiceTypeSortEnum) {
    StripeInvoiceTypeSortEnum["ClientSecretAsc"] = "CLIENT_SECRET_ASC";
    StripeInvoiceTypeSortEnum["ClientSecretDesc"] = "CLIENT_SECRET_DESC";
    StripeInvoiceTypeSortEnum["IdAsc"] = "ID_ASC";
    StripeInvoiceTypeSortEnum["IdDesc"] = "ID_DESC";
    StripeInvoiceTypeSortEnum["InvoiceIdAsc"] = "INVOICE_ID_ASC";
    StripeInvoiceTypeSortEnum["InvoiceIdDesc"] = "INVOICE_ID_DESC";
    StripeInvoiceTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    StripeInvoiceTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    StripeInvoiceTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    StripeInvoiceTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    StripeInvoiceTypeSortEnum["SaleTransactionIdAsc"] = "SALE_TRANSACTION_ID_ASC";
    StripeInvoiceTypeSortEnum["SaleTransactionIdDesc"] = "SALE_TRANSACTION_ID_DESC";
    StripeInvoiceTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    StripeInvoiceTypeSortEnum["StatusDesc"] = "STATUS_DESC";
})(StripeInvoiceTypeSortEnum = exports.StripeInvoiceTypeSortEnum || (exports.StripeInvoiceTypeSortEnum = {}));
var TokenTransferTypeSortEnum;
(function (TokenTransferTypeSortEnum) {
    TokenTransferTypeSortEnum["IdAsc"] = "ID_ASC";
    TokenTransferTypeSortEnum["IdDesc"] = "ID_DESC";
    TokenTransferTypeSortEnum["MigrationListingIdAsc"] = "MIGRATION_LISTING_ID_ASC";
    TokenTransferTypeSortEnum["MigrationListingIdDesc"] = "MIGRATION_LISTING_ID_DESC";
    TokenTransferTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    TokenTransferTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    TokenTransferTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    TokenTransferTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    TokenTransferTypeSortEnum["SaleTransactionIdAsc"] = "SALE_TRANSACTION_ID_ASC";
    TokenTransferTypeSortEnum["SaleTransactionIdDesc"] = "SALE_TRANSACTION_ID_DESC";
    TokenTransferTypeSortEnum["ToWalletAsc"] = "TO_WALLET_ASC";
    TokenTransferTypeSortEnum["ToWalletDesc"] = "TO_WALLET_DESC";
    TokenTransferTypeSortEnum["TxErrorMessageAsc"] = "TX_ERROR_MESSAGE_ASC";
    TokenTransferTypeSortEnum["TxErrorMessageDesc"] = "TX_ERROR_MESSAGE_DESC";
    TokenTransferTypeSortEnum["TxHashAsc"] = "TX_HASH_ASC";
    TokenTransferTypeSortEnum["TxHashDesc"] = "TX_HASH_DESC";
    TokenTransferTypeSortEnum["TxStatusAsc"] = "TX_STATUS_ASC";
    TokenTransferTypeSortEnum["TxStatusDesc"] = "TX_STATUS_DESC";
})(TokenTransferTypeSortEnum = exports.TokenTransferTypeSortEnum || (exports.TokenTransferTypeSortEnum = {}));
var TokenTypeSortEnum;
(function (TokenTypeSortEnum) {
    TokenTypeSortEnum["CollectionIdAsc"] = "COLLECTION_ID_ASC";
    TokenTypeSortEnum["CollectionIdDesc"] = "COLLECTION_ID_DESC";
    TokenTypeSortEnum["ContractIdAsc"] = "CONTRACT_ID_ASC";
    TokenTypeSortEnum["ContractIdDesc"] = "CONTRACT_ID_DESC";
    TokenTypeSortEnum["EditionOfIdAsc"] = "EDITION_OF_ID_ASC";
    TokenTypeSortEnum["EditionOfIdDesc"] = "EDITION_OF_ID_DESC";
    TokenTypeSortEnum["IdAsc"] = "ID_ASC";
    TokenTypeSortEnum["IdDesc"] = "ID_DESC";
    TokenTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    TokenTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    TokenTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    TokenTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    TokenTypeSortEnum["TokenIdAsc"] = "TOKEN_ID_ASC";
    TokenTypeSortEnum["TokenIdDesc"] = "TOKEN_ID_DESC";
})(TokenTypeSortEnum = exports.TokenTypeSortEnum || (exports.TokenTypeSortEnum = {}));
var Unit;
(function (Unit) {
    Unit["Cm"] = "CM";
    Unit["Ft"] = "FT";
    Unit["Inch"] = "INCH";
    Unit["M"] = "M";
    Unit["Mm"] = "MM";
    Unit["Unknown"] = "UNKNOWN";
})(Unit = exports.Unit || (exports.Unit = {}));
var UserAuthWalletTypeSortEnum;
(function (UserAuthWalletTypeSortEnum) {
    UserAuthWalletTypeSortEnum["ExternalUserIdAsc"] = "EXTERNAL_USER_ID_ASC";
    UserAuthWalletTypeSortEnum["ExternalUserIdDesc"] = "EXTERNAL_USER_ID_DESC";
    UserAuthWalletTypeSortEnum["IdAsc"] = "ID_ASC";
    UserAuthWalletTypeSortEnum["IdDesc"] = "ID_DESC";
    UserAuthWalletTypeSortEnum["IssuedByAsc"] = "ISSUED_BY_ASC";
    UserAuthWalletTypeSortEnum["IssuedByDesc"] = "ISSUED_BY_DESC";
    UserAuthWalletTypeSortEnum["WalletAsc"] = "WALLET_ASC";
    UserAuthWalletTypeSortEnum["WalletDesc"] = "WALLET_DESC";
})(UserAuthWalletTypeSortEnum = exports.UserAuthWalletTypeSortEnum || (exports.UserAuthWalletTypeSortEnum = {}));
var UserProfileTypeSortEnum;
(function (UserProfileTypeSortEnum) {
    UserProfileTypeSortEnum["AccountTypeAsc"] = "ACCOUNT_TYPE_ASC";
    UserProfileTypeSortEnum["AccountTypeDesc"] = "ACCOUNT_TYPE_DESC";
    UserProfileTypeSortEnum["BackOfIdS3LinkAsc"] = "BACK_OF_ID_S3_LINK_ASC";
    UserProfileTypeSortEnum["BackOfIdS3LinkDesc"] = "BACK_OF_ID_S3_LINK_DESC";
    UserProfileTypeSortEnum["BusinessNameAsc"] = "BUSINESS_NAME_ASC";
    UserProfileTypeSortEnum["BusinessNameDesc"] = "BUSINESS_NAME_DESC";
    UserProfileTypeSortEnum["CityAsc"] = "CITY_ASC";
    UserProfileTypeSortEnum["CityDesc"] = "CITY_DESC";
    UserProfileTypeSortEnum["CountryAsc"] = "COUNTRY_ASC";
    UserProfileTypeSortEnum["CountryDesc"] = "COUNTRY_DESC";
    UserProfileTypeSortEnum["DateOfBirthAsc"] = "DATE_OF_BIRTH_ASC";
    UserProfileTypeSortEnum["DateOfBirthDesc"] = "DATE_OF_BIRTH_DESC";
    UserProfileTypeSortEnum["ExternalUserIdAsc"] = "EXTERNAL_USER_ID_ASC";
    UserProfileTypeSortEnum["ExternalUserIdDesc"] = "EXTERNAL_USER_ID_DESC";
    UserProfileTypeSortEnum["FirstNameAsc"] = "FIRST_NAME_ASC";
    UserProfileTypeSortEnum["FirstNameDesc"] = "FIRST_NAME_DESC";
    UserProfileTypeSortEnum["FrontOfIdS3LinkAsc"] = "FRONT_OF_ID_S3_LINK_ASC";
    UserProfileTypeSortEnum["FrontOfIdS3LinkDesc"] = "FRONT_OF_ID_S3_LINK_DESC";
    UserProfileTypeSortEnum["LastNameAsc"] = "LAST_NAME_ASC";
    UserProfileTypeSortEnum["LastNameDesc"] = "LAST_NAME_DESC";
    UserProfileTypeSortEnum["MarketTypeAsc"] = "MARKET_TYPE_ASC";
    UserProfileTypeSortEnum["MarketTypeDesc"] = "MARKET_TYPE_DESC";
    UserProfileTypeSortEnum["PhoneNumberAsc"] = "PHONE_NUMBER_ASC";
    UserProfileTypeSortEnum["PhoneNumberDesc"] = "PHONE_NUMBER_DESC";
    UserProfileTypeSortEnum["ProofOfAddressS3LinkAsc"] = "PROOF_OF_ADDRESS_S3_LINK_ASC";
    UserProfileTypeSortEnum["ProofOfAddressS3LinkDesc"] = "PROOF_OF_ADDRESS_S3_LINK_DESC";
    UserProfileTypeSortEnum["ProofOfFundsS3LinkAsc"] = "PROOF_OF_FUNDS_S3_LINK_ASC";
    UserProfileTypeSortEnum["ProofOfFundsS3LinkDesc"] = "PROOF_OF_FUNDS_S3_LINK_DESC";
    UserProfileTypeSortEnum["PurchasePowerAsc"] = "PURCHASE_POWER_ASC";
    UserProfileTypeSortEnum["PurchasePowerDesc"] = "PURCHASE_POWER_DESC";
    UserProfileTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    UserProfileTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    UserProfileTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    UserProfileTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    UserProfileTypeSortEnum["StateOrProvinceAsc"] = "STATE_OR_PROVINCE_ASC";
    UserProfileTypeSortEnum["StateOrProvinceDesc"] = "STATE_OR_PROVINCE_DESC";
    UserProfileTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    UserProfileTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    UserProfileTypeSortEnum["StreetAsc"] = "STREET_ASC";
    UserProfileTypeSortEnum["StreetDesc"] = "STREET_DESC";
    UserProfileTypeSortEnum["ZipCodeAsc"] = "ZIP_CODE_ASC";
    UserProfileTypeSortEnum["ZipCodeDesc"] = "ZIP_CODE_DESC";
})(UserProfileTypeSortEnum = exports.UserProfileTypeSortEnum || (exports.UserProfileTypeSortEnum = {}));
var UserRole;
(function (UserRole) {
    UserRole["Buyer"] = "BUYER";
    UserRole["Seller"] = "SELLER";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserSocialLinkTypeSortEnum;
(function (UserSocialLinkTypeSortEnum) {
    UserSocialLinkTypeSortEnum["ExternalUserIdAsc"] = "EXTERNAL_USER_ID_ASC";
    UserSocialLinkTypeSortEnum["ExternalUserIdDesc"] = "EXTERNAL_USER_ID_DESC";
    UserSocialLinkTypeSortEnum["IdAsc"] = "ID_ASC";
    UserSocialLinkTypeSortEnum["IdDesc"] = "ID_DESC";
    UserSocialLinkTypeSortEnum["LinkAsc"] = "LINK_ASC";
    UserSocialLinkTypeSortEnum["LinkDesc"] = "LINK_DESC";
    UserSocialLinkTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    UserSocialLinkTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    UserSocialLinkTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    UserSocialLinkTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
})(UserSocialLinkTypeSortEnum = exports.UserSocialLinkTypeSortEnum || (exports.UserSocialLinkTypeSortEnum = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Approved"] = "APPROVED";
    UserStatus["Declined"] = "DECLINED";
    UserStatus["Draft"] = "DRAFT";
    UserStatus["Waitingaproval"] = "WAITINGAPROVAL";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var UserTypeSortEnum;
(function (UserTypeSortEnum) {
    UserTypeSortEnum["ArtistFollowedEnablePushNotificationsForNewArtworkAsc"] = "ARTIST_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_FOR_NEW_ARTWORK_ASC";
    UserTypeSortEnum["ArtistFollowedEnablePushNotificationsForNewArtworkDesc"] = "ARTIST_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_FOR_NEW_ARTWORK_DESC";
    UserTypeSortEnum["ArtistGeneralEnablePushNotificationsAsc"] = "ARTIST_GENERAL_ENABLE_PUSH_NOTIFICATIONS_ASC";
    UserTypeSortEnum["ArtistGeneralEnablePushNotificationsDesc"] = "ARTIST_GENERAL_ENABLE_PUSH_NOTIFICATIONS_DESC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsLiveAsc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_LIVE_ASC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsLiveDesc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_LIVE_DESC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsOnlineAsc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_ONLINE_ASC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsOnlineDesc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_ONLINE_DESC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsResultsAsc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_RESULTS_ASC";
    UserTypeSortEnum["AuctionsFollowedEnablePushNotificationsResultsDesc"] = "AUCTIONS_FOLLOWED_ENABLE_PUSH_NOTIFICATIONS_RESULTS_DESC";
    UserTypeSortEnum["AuctionsGeneralEnablePushNotificationsAsc"] = "AUCTIONS_GENERAL_ENABLE_PUSH_NOTIFICATIONS_ASC";
    UserTypeSortEnum["AuctionsGeneralEnablePushNotificationsDesc"] = "AUCTIONS_GENERAL_ENABLE_PUSH_NOTIFICATIONS_DESC";
    UserTypeSortEnum["AvatarImageUrlAsc"] = "AVATAR_IMAGE_URL_ASC";
    UserTypeSortEnum["AvatarImageUrlDesc"] = "AVATAR_IMAGE_URL_DESC";
    UserTypeSortEnum["BiographyAsc"] = "BIOGRAPHY_ASC";
    UserTypeSortEnum["BiographyDesc"] = "BIOGRAPHY_DESC";
    UserTypeSortEnum["CanAccessDealroomsAsc"] = "CAN_ACCESS_DEALROOMS_ASC";
    UserTypeSortEnum["CanAccessDealroomsDesc"] = "CAN_ACCESS_DEALROOMS_DESC";
    UserTypeSortEnum["CognitoSubjectIdAsc"] = "COGNITO_SUBJECT_ID_ASC";
    UserTypeSortEnum["CognitoSubjectIdDesc"] = "COGNITO_SUBJECT_ID_DESC";
    UserTypeSortEnum["CollectionEstimateHighAsc"] = "COLLECTION_ESTIMATE_HIGH_ASC";
    UserTypeSortEnum["CollectionEstimateHighDesc"] = "COLLECTION_ESTIMATE_HIGH_DESC";
    UserTypeSortEnum["CollectionEstimateLowAsc"] = "COLLECTION_ESTIMATE_LOW_ASC";
    UserTypeSortEnum["CollectionEstimateLowDesc"] = "COLLECTION_ESTIMATE_LOW_DESC";
    UserTypeSortEnum["CollectionEstimatePriceAsc"] = "COLLECTION_ESTIMATE_PRICE_ASC";
    UserTypeSortEnum["CollectionEstimatePriceDesc"] = "COLLECTION_ESTIMATE_PRICE_DESC";
    UserTypeSortEnum["CollectionPriceMomentum_12MoAsc"] = "COLLECTION_PRICE_MOMENTUM_12MO_ASC";
    UserTypeSortEnum["CollectionPriceMomentum_12MoDesc"] = "COLLECTION_PRICE_MOMENTUM_12MO_DESC";
    UserTypeSortEnum["CollectionPriceMomentum_60MoAsc"] = "COLLECTION_PRICE_MOMENTUM_60MO_ASC";
    UserTypeSortEnum["CollectionPriceMomentum_60MoDesc"] = "COLLECTION_PRICE_MOMENTUM_60MO_DESC";
    UserTypeSortEnum["CollectionPriceMomentum_120MoAsc"] = "COLLECTION_PRICE_MOMENTUM_120MO_ASC";
    UserTypeSortEnum["CollectionPriceMomentum_120MoDesc"] = "COLLECTION_PRICE_MOMENTUM_120MO_DESC";
    UserTypeSortEnum["CollectionPriceSoldAsc"] = "COLLECTION_PRICE_SOLD_ASC";
    UserTypeSortEnum["CollectionPriceSoldDesc"] = "COLLECTION_PRICE_SOLD_DESC";
    UserTypeSortEnum["DealEnablePushNotificationsBuyerUpdateAsc"] = "DEAL_ENABLE_PUSH_NOTIFICATIONS_BUYER_UPDATE_ASC";
    UserTypeSortEnum["DealEnablePushNotificationsBuyerUpdateDesc"] = "DEAL_ENABLE_PUSH_NOTIFICATIONS_BUYER_UPDATE_DESC";
    UserTypeSortEnum["DealEnablePushNotificationsSellerUpdateAsc"] = "DEAL_ENABLE_PUSH_NOTIFICATIONS_SELLER_UPDATE_ASC";
    UserTypeSortEnum["DealEnablePushNotificationsSellerUpdateDesc"] = "DEAL_ENABLE_PUSH_NOTIFICATIONS_SELLER_UPDATE_DESC";
    UserTypeSortEnum["DeletionRequestDatetimeAsc"] = "DELETION_REQUEST_DATETIME_ASC";
    UserTypeSortEnum["DeletionRequestDatetimeDesc"] = "DELETION_REQUEST_DATETIME_DESC";
    UserTypeSortEnum["EmailAsc"] = "EMAIL_ASC";
    UserTypeSortEnum["EmailDesc"] = "EMAIL_DESC";
    UserTypeSortEnum["EnablePushNotificationsAsc"] = "ENABLE_PUSH_NOTIFICATIONS_ASC";
    UserTypeSortEnum["EnablePushNotificationsDesc"] = "ENABLE_PUSH_NOTIFICATIONS_DESC";
    UserTypeSortEnum["ExternalIdAsc"] = "EXTERNAL_ID_ASC";
    UserTypeSortEnum["ExternalIdDesc"] = "EXTERNAL_ID_DESC";
    UserTypeSortEnum["FirstNameAsc"] = "FIRST_NAME_ASC";
    UserTypeSortEnum["FirstNameDesc"] = "FIRST_NAME_DESC";
    UserTypeSortEnum["FullNameAsc"] = "FULL_NAME_ASC";
    UserTypeSortEnum["FullNameDesc"] = "FULL_NAME_DESC";
    UserTypeSortEnum["IsDisabledAsc"] = "IS_DISABLED_ASC";
    UserTypeSortEnum["IsDisabledDesc"] = "IS_DISABLED_DESC";
    UserTypeSortEnum["IsInternalAsc"] = "IS_INTERNAL_ASC";
    UserTypeSortEnum["IsInternalDesc"] = "IS_INTERNAL_DESC";
    UserTypeSortEnum["IsTermsAndConditionsAcceptedAsc"] = "IS_TERMS_AND_CONDITIONS_ACCEPTED_ASC";
    UserTypeSortEnum["IsTermsAndConditionsAcceptedDesc"] = "IS_TERMS_AND_CONDITIONS_ACCEPTED_DESC";
    UserTypeSortEnum["LastNameAsc"] = "LAST_NAME_ASC";
    UserTypeSortEnum["LastNameDesc"] = "LAST_NAME_DESC";
    UserTypeSortEnum["NicknameAsc"] = "NICKNAME_ASC";
    UserTypeSortEnum["NicknameDesc"] = "NICKNAME_DESC";
    UserTypeSortEnum["PartnerNameAsc"] = "PARTNER_NAME_ASC";
    UserTypeSortEnum["PartnerNameDesc"] = "PARTNER_NAME_DESC";
    UserTypeSortEnum["PhoneNumberAsc"] = "PHONE_NUMBER_ASC";
    UserTypeSortEnum["PhoneNumberDesc"] = "PHONE_NUMBER_DESC";
    UserTypeSortEnum["PreferredCurrencyAsc"] = "PREFERRED_CURRENCY_ASC";
    UserTypeSortEnum["PreferredCurrencyDesc"] = "PREFERRED_CURRENCY_DESC";
    UserTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    UserTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    UserTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    UserTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    UserTypeSortEnum["ShopifyUserIdAsc"] = "SHOPIFY_USER_ID_ASC";
    UserTypeSortEnum["ShopifyUserIdDesc"] = "SHOPIFY_USER_ID_DESC";
    UserTypeSortEnum["StripeCustomerIdAsc"] = "STRIPE_CUSTOMER_ID_ASC";
    UserTypeSortEnum["StripeCustomerIdDesc"] = "STRIPE_CUSTOMER_ID_DESC";
    UserTypeSortEnum["ToDeleteAsc"] = "TO_DELETE_ASC";
    UserTypeSortEnum["ToDeleteDesc"] = "TO_DELETE_DESC";
    UserTypeSortEnum["VerifiedAsc"] = "VERIFIED_ASC";
    UserTypeSortEnum["VerifiedDesc"] = "VERIFIED_DESC";
})(UserTypeSortEnum = exports.UserTypeSortEnum || (exports.UserTypeSortEnum = {}));
var UserWalletTypeSortEnum;
(function (UserWalletTypeSortEnum) {
    UserWalletTypeSortEnum["ExternalUserIdAsc"] = "EXTERNAL_USER_ID_ASC";
    UserWalletTypeSortEnum["ExternalUserIdDesc"] = "EXTERNAL_USER_ID_DESC";
    UserWalletTypeSortEnum["IdAsc"] = "ID_ASC";
    UserWalletTypeSortEnum["IdDesc"] = "ID_DESC";
    UserWalletTypeSortEnum["IssuedByAsc"] = "ISSUED_BY_ASC";
    UserWalletTypeSortEnum["IssuedByDesc"] = "ISSUED_BY_DESC";
    UserWalletTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    UserWalletTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    UserWalletTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    UserWalletTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    UserWalletTypeSortEnum["WalletAsc"] = "WALLET_ASC";
    UserWalletTypeSortEnum["WalletDesc"] = "WALLET_DESC";
})(UserWalletTypeSortEnum = exports.UserWalletTypeSortEnum || (exports.UserWalletTypeSortEnum = {}));
var WhitelistTypeSortEnum;
(function (WhitelistTypeSortEnum) {
    WhitelistTypeSortEnum["AmountAsc"] = "AMOUNT_ASC";
    WhitelistTypeSortEnum["AmountDesc"] = "AMOUNT_DESC";
    WhitelistTypeSortEnum["ContractIdAsc"] = "CONTRACT_ID_ASC";
    WhitelistTypeSortEnum["ContractIdDesc"] = "CONTRACT_ID_DESC";
    WhitelistTypeSortEnum["EditionIdAsc"] = "EDITION_ID_ASC";
    WhitelistTypeSortEnum["EditionIdDesc"] = "EDITION_ID_DESC";
    WhitelistTypeSortEnum["IdAsc"] = "ID_ASC";
    WhitelistTypeSortEnum["IdDesc"] = "ID_DESC";
    WhitelistTypeSortEnum["NameAsc"] = "NAME_ASC";
    WhitelistTypeSortEnum["NameDesc"] = "NAME_DESC";
    WhitelistTypeSortEnum["PriceAsc"] = "PRICE_ASC";
    WhitelistTypeSortEnum["PriceDesc"] = "PRICE_DESC";
})(WhitelistTypeSortEnum = exports.WhitelistTypeSortEnum || (exports.WhitelistTypeSortEnum = {}));
var WhitelistWalletTypeSortEnum;
(function (WhitelistWalletTypeSortEnum) {
    WhitelistWalletTypeSortEnum["AddressAsc"] = "ADDRESS_ASC";
    WhitelistWalletTypeSortEnum["AddressDesc"] = "ADDRESS_DESC";
    WhitelistWalletTypeSortEnum["IdAsc"] = "ID_ASC";
    WhitelistWalletTypeSortEnum["IdDesc"] = "ID_DESC";
    WhitelistWalletTypeSortEnum["WhitelistIdAsc"] = "WHITELIST_ID_ASC";
    WhitelistWalletTypeSortEnum["WhitelistIdDesc"] = "WHITELIST_ID_DESC";
})(WhitelistWalletTypeSortEnum = exports.WhitelistWalletTypeSortEnum || (exports.WhitelistWalletTypeSortEnum = {}));
var WishlistPurchaseTimeline;
(function (WishlistPurchaseTimeline) {
    WishlistPurchaseTimeline["Immediate"] = "IMMEDIATE";
    WishlistPurchaseTimeline["OneYear"] = "ONE_YEAR";
    WishlistPurchaseTimeline["SixMonths"] = "SIX_MONTHS";
    WishlistPurchaseTimeline["ThreeMonths"] = "THREE_MONTHS";
})(WishlistPurchaseTimeline = exports.WishlistPurchaseTimeline || (exports.WishlistPurchaseTimeline = {}));
var WishlistSize;
(function (WishlistSize) {
    WishlistSize["Large"] = "LARGE";
    WishlistSize["Medium"] = "MEDIUM";
    WishlistSize["Small"] = "SMALL";
})(WishlistSize = exports.WishlistSize || (exports.WishlistSize = {}));
var WishlistStatus;
(function (WishlistStatus) {
    WishlistStatus["Archived"] = "ARCHIVED";
    WishlistStatus["Declined"] = "DECLINED";
    WishlistStatus["Draft"] = "DRAFT";
    WishlistStatus["Fulfilled"] = "FULFILLED";
    WishlistStatus["Internal"] = "INTERNAL";
    WishlistStatus["New"] = "NEW";
    WishlistStatus["Private"] = "PRIVATE";
    WishlistStatus["Published"] = "PUBLISHED";
    WishlistStatus["Unconfirmed"] = "UNCONFIRMED";
})(WishlistStatus = exports.WishlistStatus || (exports.WishlistStatus = {}));
var WishlistTypeSortEnum;
(function (WishlistTypeSortEnum) {
    WishlistTypeSortEnum["ArtistAsc"] = "ARTIST_ASC";
    WishlistTypeSortEnum["ArtistDesc"] = "ARTIST_DESC";
    WishlistTypeSortEnum["ArtistIdAsc"] = "ARTIST_ID_ASC";
    WishlistTypeSortEnum["ArtistIdDesc"] = "ARTIST_ID_DESC";
    WishlistTypeSortEnum["ArtistNameAsc"] = "ARTIST_NAME_ASC";
    WishlistTypeSortEnum["ArtistNameDesc"] = "ARTIST_NAME_DESC";
    WishlistTypeSortEnum["ArtworkCreationYearEndAsc"] = "ARTWORK_CREATION_YEAR_END_ASC";
    WishlistTypeSortEnum["ArtworkCreationYearEndDesc"] = "ARTWORK_CREATION_YEAR_END_DESC";
    WishlistTypeSortEnum["ArtworkCreationYearStartAsc"] = "ARTWORK_CREATION_YEAR_START_ASC";
    WishlistTypeSortEnum["ArtworkCreationYearStartDesc"] = "ARTWORK_CREATION_YEAR_START_DESC";
    WishlistTypeSortEnum["ArtworkLocationAsc"] = "ARTWORK_LOCATION_ASC";
    WishlistTypeSortEnum["ArtworkLocationDesc"] = "ARTWORK_LOCATION_DESC";
    WishlistTypeSortEnum["AuctionHouseAsc"] = "AUCTION_HOUSE_ASC";
    WishlistTypeSortEnum["AuctionHouseDesc"] = "AUCTION_HOUSE_DESC";
    WishlistTypeSortEnum["AuctionHouseIdAsc"] = "AUCTION_HOUSE_ID_ASC";
    WishlistTypeSortEnum["AuctionHouseIdDesc"] = "AUCTION_HOUSE_ID_DESC";
    WishlistTypeSortEnum["AuctionSaleDateAsc"] = "AUCTION_SALE_DATE_ASC";
    WishlistTypeSortEnum["AuctionSaleDateDesc"] = "AUCTION_SALE_DATE_DESC";
    WishlistTypeSortEnum["BudgetMaxAsc"] = "BUDGET_MAX_ASC";
    WishlistTypeSortEnum["BudgetMaxDesc"] = "BUDGET_MAX_DESC";
    WishlistTypeSortEnum["BudgetMinAsc"] = "BUDGET_MIN_ASC";
    WishlistTypeSortEnum["BudgetMinDesc"] = "BUDGET_MIN_DESC";
    WishlistTypeSortEnum["CategoryAsc"] = "CATEGORY_ASC";
    WishlistTypeSortEnum["CategoryDesc"] = "CATEGORY_DESC";
    WishlistTypeSortEnum["CategoryIdAsc"] = "CATEGORY_ID_ASC";
    WishlistTypeSortEnum["CategoryIdDesc"] = "CATEGORY_ID_DESC";
    WishlistTypeSortEnum["CurrencyCodeAsc"] = "CURRENCY_CODE_ASC";
    WishlistTypeSortEnum["CurrencyCodeDesc"] = "CURRENCY_CODE_DESC";
    WishlistTypeSortEnum["DescriptionAsc"] = "DESCRIPTION_ASC";
    WishlistTypeSortEnum["DescriptionDesc"] = "DESCRIPTION_DESC";
    WishlistTypeSortEnum["IdAsc"] = "ID_ASC";
    WishlistTypeSortEnum["IdDesc"] = "ID_DESC";
    WishlistTypeSortEnum["IsHiddenAsc"] = "IS_HIDDEN_ASC";
    WishlistTypeSortEnum["IsHiddenDesc"] = "IS_HIDDEN_DESC";
    WishlistTypeSortEnum["LastInterestConfirmationDatetimeAsc"] = "LAST_INTEREST_CONFIRMATION_DATETIME_ASC";
    WishlistTypeSortEnum["LastInterestConfirmationDatetimeDesc"] = "LAST_INTEREST_CONFIRMATION_DATETIME_DESC";
    WishlistTypeSortEnum["MaterialsAsc"] = "MATERIALS_ASC";
    WishlistTypeSortEnum["MaterialsDesc"] = "MATERIALS_DESC";
    WishlistTypeSortEnum["PublishedAtAsc"] = "PUBLISHED_AT_ASC";
    WishlistTypeSortEnum["PublishedAtDesc"] = "PUBLISHED_AT_DESC";
    WishlistTypeSortEnum["PurchaseTimelineAsc"] = "PURCHASE_TIMELINE_ASC";
    WishlistTypeSortEnum["PurchaseTimelineDesc"] = "PURCHASE_TIMELINE_DESC";
    WishlistTypeSortEnum["RecordCreatedAsc"] = "RECORD_CREATED_ASC";
    WishlistTypeSortEnum["RecordCreatedDesc"] = "RECORD_CREATED_DESC";
    WishlistTypeSortEnum["RecordModifiedAsc"] = "RECORD_MODIFIED_ASC";
    WishlistTypeSortEnum["RecordModifiedDesc"] = "RECORD_MODIFIED_DESC";
    WishlistTypeSortEnum["SaleNameAsc"] = "SALE_NAME_ASC";
    WishlistTypeSortEnum["SaleNameDesc"] = "SALE_NAME_DESC";
    WishlistTypeSortEnum["SizesAsc"] = "SIZES_ASC";
    WishlistTypeSortEnum["SizesDesc"] = "SIZES_DESC";
    WishlistTypeSortEnum["SizeAsc"] = "SIZE_ASC";
    WishlistTypeSortEnum["SizeDesc"] = "SIZE_DESC";
    WishlistTypeSortEnum["StatusAsc"] = "STATUS_ASC";
    WishlistTypeSortEnum["StatusDesc"] = "STATUS_DESC";
    WishlistTypeSortEnum["TitleAsc"] = "TITLE_ASC";
    WishlistTypeSortEnum["TitleDesc"] = "TITLE_DESC";
    WishlistTypeSortEnum["UserAsc"] = "USER_ASC";
    WishlistTypeSortEnum["UserDesc"] = "USER_DESC";
    WishlistTypeSortEnum["UserIdAsc"] = "USER_ID_ASC";
    WishlistTypeSortEnum["UserIdDesc"] = "USER_ID_DESC";
    WishlistTypeSortEnum["YearCreatedAsc"] = "YEAR_CREATED_ASC";
    WishlistTypeSortEnum["YearCreatedDesc"] = "YEAR_CREATED_DESC";
})(WishlistTypeSortEnum = exports.WishlistTypeSortEnum || (exports.WishlistTypeSortEnum = {}));
